/* eslint-disable no-dupe-keys, no-template-curly-in-string */
import React, { createContext, startTransition, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const LANGUAGE_STORAGE_KEY = 'app_language';

const translations = {
  en: {
    app_name: 'Football Field Booking',
    nav_home: 'Home',
    nav_fields: 'Fields',
    nav_league: 'League',
    nav_leagues: 'Leagues',
    nav_teams: 'Teams',
    nav_login: 'Login',
    nav_register: 'Register',
    nav_dashboard: 'Dashboard',
    nav_bookings: 'Bookings',
    nav_matches: 'Matches',
    nav_open_matches: 'Open Matches',
    nav_profile: 'Profile',
    nav_notifications: 'Notifications',
    nav_analytics: 'Analytics',
    nav_my_fields: 'My Fields',
    nav_booking_requests: 'Booking Requests',
    nav_manage_users: 'Manage Users',
    nav_role_requests: 'Role Requests',
    nav_chat: 'Chat',
    nav_settings: 'Settings',
    action_logout: 'Logout',
    action_go_dashboard: 'Go to Dashboard',
    action_add_field: 'Add field',
    action_review_requests: 'Review requests',
    action_manage_fields: 'Manage fields',
    action_go_to_requests: 'Go to requests',
    action_edit: 'Edit',
    action_open_field: 'Open field',
    action_close_field: 'Close field',
    action_save: 'Save',
    action_confirm: 'Confirm',
    action_decline: 'Decline',
    action_cancel: 'Cancel',
    action_back: 'Back',
    action_back_to_fields: 'Back to Fields',
    action_back_to_bookings: 'Back to Bookings',
    action_book_now: 'Book Now',
    action_open_settings: 'Open Settings',
    action_create_team: 'Create Team',
    workspace_player: 'Player & Captain Panel',
    workspace_owner: 'Field Owner Panel',
    label_workspace: 'Workspace',
    label_language: 'Language',
    language_en: 'English',
    language_km: 'Khmer',
    role_user: 'User',
    role_player: 'Player',
    role_captain: 'Captain',
    role_admin: 'Admin',
    role_field_owner: 'Field Owner',
    page_dashboard_subtitle: 'Overview of your activity and updates',
    page_fields_subtitle: 'Browse and discover available football fields',
    page_league_subtitle: 'Track fixtures, results, and standings',
    page_teams_subtitle: 'Manage your team and membership requests',
    page_bookings_subtitle: 'Create and manage your field bookings',
    page_open_matches_subtitle: 'Find and respond to open opponent matches',
    page_notifications_subtitle: 'Review invitations and request updates',
    page_profile_subtitle: 'Update your account and preferences',
    page_settings_subtitle: 'Manage account preferences and role requests',
    page_manage_users_subtitle: 'Admin user management area',
    page_role_requests_subtitle: 'Review pending role access requests',
    page_chat_subtitle: 'Talk directly with users across the platform',
    owner_badge: 'Field Owner',
    owner_dashboard_title: 'Owner Dashboard',
    owner_dashboard_subtitle: 'Track your fields, review booking requests, and keep your schedule under control.',
    owner_pending_title: 'Pending booking requests',
    owner_pending_subtitle: 'Approve or reject new requests from teams.',
    owner_pending_empty_title: 'No pending requests',
    owner_pending_empty_description: 'When players create bookings for your fields, they will show up here.',
    owner_upcoming_title: 'Upcoming confirmed',
    owner_upcoming_subtitle: 'Your next scheduled bookings after approval.',
    owner_upcoming_empty_title: 'No upcoming bookings',
    owner_upcoming_empty_description: 'Confirm pending requests to see your upcoming schedule.',
    owner_my_fields_title: 'My fields',
    owner_my_fields_subtitle: 'Your venues, availability, and pricing at a glance.',
    owner_fields_subtitle: 'Your venues, availability, and pricing at a glance.',
    owner_no_fields_title: 'No fields yet',
    owner_no_fields_description: 'Create your first field to start receiving booking requests.',
    owner_fields_empty_description: 'Create your first field to start receiving booking requests.',
    owner_completed_summary: 'Completed bookings: {{count}}. Revenue estimate includes owner-approved bookings, even if they are cancelled later.',
    owner_pending_count: '{{count}} pending',
    owner_upcoming_count: '{{count}} upcoming',
    stat_my_fields: 'My Fields',
    stat_pending_requests: 'Pending Requests',
    stat_confirmed: 'Confirmed',
    stat_revenue_est: 'Revenue (est.)',
    booking_status_confirmed: 'confirmed'
    ,
    common_all: 'All',
    common_pending: 'Pending',
    common_confirmed: 'Confirmed',
    common_completed: 'Completed',
    common_cancelled: 'Cancelled',
    common_loading: 'Loading...',
    common_saving: 'Saving...',
    common_updating: 'Updating...',
    common_deleting: 'Deleting...',
    common_created: 'Created',
    common_new: 'New',
    common_current: 'Current',
    common_unknown: 'Unknown',
    surface_artificial_turf: 'Artificial Turf',
    surface_natural_grass: 'Natural Grass',
    surface_concrete: 'Concrete',
    surface_indoor: 'Indoor',
    owner_field_edit_badge: 'Edit Field',
    owner_field_create_badge: 'Create Field',
    owner_field_edit_title: 'Update Field Information',
    owner_field_create_title: 'Add a New Field',
    owner_field_modal_subtitle: 'Update pricing, location, amenities, and photos in one place.',
    owner_field_close_form: 'Close field form',
    owner_field_live_preview: 'Live Preview',
    owner_field_set_price: 'Set price',
    owner_field_type_label: 'Field type',
    owner_field_set_capacity: 'Set capacity',
    owner_field_details_title: 'Field Details',
    owner_field_details_subtitle: 'Set the essential details players see before booking.',
    owner_field_name_label: 'Field Name',
    owner_field_name_placeholder: 'Field name',
    owner_field_price_label: 'Price Per Hour',
    owner_field_price_placeholder: 'Price per hour',
    owner_field_capacity_label: 'Capacity',
    owner_field_capacity_placeholder: 'Capacity',
    owner_field_discount_label: 'Discount Percent',
    owner_field_type_title: 'Field Type',
    owner_field_surface_title: 'Surface Type',
    owner_field_amenities_label: 'Amenities',
    owner_field_amenities_placeholder: 'parking, showers, lights',
    owner_field_location_title: 'Location',
    owner_field_location_subtitle: 'Search, click, or drag the pin to set the field location.',
    owner_field_photos_title: 'Photos',
    owner_field_photos_subtitle: 'Upload up to 5 images. Images are compressed before upload to keep pages fast.',
    owner_field_change_photos: 'Change Photos',
    owner_field_upload_photos: 'Upload Photos',
    owner_field_new_photos_ready: 'New photos are ready and will replace current photos when you click Save',
    owner_field_showing_current_images: 'Showing current image(s)',
    owner_field_no_photos_selected: 'No photos selected yet.',
    owner_field_description_title: 'Field Description',
    owner_field_description_subtitle: 'Share what makes this field special for players and captains.',
    owner_field_description_placeholder: 'Field description',
    owner_field_ready_to_save: 'Ready to save',
    owner_field_fill_required: 'Fill required details: name, price, capacity, and location',
    fields_title: 'Fields',
    fields_subtitle: 'Browse football fields near you.',
    fields_results: '{{count}} results',
    fields_search: 'Search',
    fields_search_placeholder: 'Search fields...',
    fields_filter_type: 'Field Type',
    fields_filter_surface: 'Surface Type',
    fields_filter_price: 'Max Price/Hour',
    fields_all_types: 'All Types',
    fields_all_surfaces: 'All Surfaces',
    fields_no_rating: 'No rating',
    fields_no_rating_yet: 'No ratings yet',
    field_ratings_count: '{{count}} ratings',
    field_per_hour_short: 'hr',
    fields_reviews: '{{count}} reviews',
    fields_delete_title: 'Delete Field',
    fields_message_to_owner: 'Message to owner',
    fields_clear_filters: 'Clear filters',
    fields_no_fields_found: 'No fields found',
    fields_adjust_filters: 'Try adjusting your search or filters.',
    fields_load_more: 'Load More Fields',
    fields_delete_message: 'Send a message to owner before deleting {{name}}.',
    fields_delete_reason_placeholder: 'Explain why this field is being deleted...',
    fields_send_delete: 'Send & Delete',
    fields_owner_label: 'Owner:',
    fields_delete_message_required: 'Please enter a message to owner before deleting.',
    fields_load_failed: 'Failed to load fields',
    fields_delete_failed: 'Failed to delete field',
    fields_booking_access_required: 'Booking access is required.',
    fields_booking_access_title: 'Booking Access',
    fields_only_available: 'Only fields with status "available" can be booked.',
    booking_title: 'Bookings',
    booking_subtitle_manage: 'Manage your football field bookings',
    booking_subtitle_track: 'Track your bookings here.',
    booking_new: 'New Booking',
    booking_request_captain: 'Request Captain Access',
    booking_filter_status: 'Status',
    booking_filter_opponent: 'Opponent Match',
    booking_open_for_opponents: 'Open for Opponents',
    booking_not_open: 'Not Open',
    booking_cancel_confirm: 'Do you want to cancel your booking?',
    booking_cancel_title: 'Cancel Booking',
    booking_cancel_button: 'Cancel Booking',
    booking_complete: 'Complete',
    booking_matched: 'Matched',
    booking_join_requests: 'Join Requests',
    booking_no_requests: 'No requests yet.',
    booking_loading_requests: 'Loading requests...',
    booking_booked_by: 'Booked by',
    booking_unknown_field: 'Unknown Field',
    booking_no_team: 'No team',
    booking_waiting_owner_approval: 'Waiting for owner approval. This slot is still open until confirmed.',
    booking_already_matched: 'Already matched',
    booking_team_a: 'Team A',
    booking_cancelling_match: 'Cancelling Match...',
    booking_cancel_matched_opponent: 'Cancel Matched Opponent',
    booking_open_match: 'Open Match',
    booking_close_match: 'Close Match',
    booking_unknown_team: 'Unknown team',
    booking_unknown_captain: 'Unknown captain',
    booking_approve_join: 'Approve Join',
    booking_empty_title: 'No bookings found',
    booking_empty_create_first: 'Create your first booking to get started.',
    booking_empty_request_captain: 'Please request to become captain in Settings.',
    booking_empty_filtered: 'No bookings found for the selected filters.',
    booking_load_failed: 'Failed to load bookings',
    booking_update_success: 'Booking updated successfully.',
    booking_update_failed: 'Failed to update booking status',
    booking_cancellation_sent: 'Booking cancellation sent successfully.',
    booking_cancellation_failed: 'Failed to request cancellation',
    booking_opponent_setting_updated: 'Opponent match setting updated.',
    booking_open_opponents_failed: 'Failed to update Open for Opponents',
    booking_cancel_matched_title: 'Cancel Matched Game',
    booking_cancel_matched_confirm: 'Do you want to cancel this matched game: {{home}} vs {{away}}?',
    booking_matched_cancelled_success: 'Matched booking cancelled successfully.',
    booking_cancel_matched_failed: 'Failed to cancel matched match',
    booking_join_request_approved: 'Join request approved successfully.',
    booking_join_request_rejected: 'Join request rejected successfully.',
    booking_join_request_approve_failed: 'Failed to approve join request',
    booking_join_request_reject_failed: 'Failed to reject join request',
    booking_cancellation_requested: 'Cancellation requested. Waiting for field owner review.',
    booking_request_cancellation: 'Request Cancellation',
    booking_send_cancellation_for: 'Send a cancellation request for',
    booking_this_booking: 'this booking',
    booking_reason_for_cancellation: 'Reason for cancellation',
    booking_reason_placeholder: 'Optional: explain why you want to cancel this booking...',
    booking_requesting: 'Requesting...',
    booking_send_request: 'Send Request',
    booking_vs: 'vs',
    team_captain: 'Captain',
    create_booking_access_required: 'Access Required',
    create_booking_access_description: 'You need captain, field owner, or admin access to book fields.',
    create_booking_title: 'Create New Booking',
    create_booking_subtitle: 'Book a football field for your team',
    create_booking_select_field: 'Select Field *',
    create_booking_select_team: 'Select Team *',
    create_booking_choose_field: 'Choose a field...',
    create_booking_choose_team: 'Choose a team...',
    create_booking_jersey_colors: 'Jersey Colors',
    create_booking_need_team: 'You need a team before booking.',
    create_booking_start_time: 'Start Time *',
    create_booking_duration: 'Duration *',
    create_booking_notes: 'Notes',
    create_booking_notes_placeholder: 'Add any booking notes...',
    create_booking_summary: 'Booking Summary',
    create_booking_field: 'Field',
    create_booking_team: 'Team',
    create_booking_date_time: 'Date & Time',
    create_booking_total_price: 'Total Price',
    create_booking_field_details: 'Field Details for Captain',
    create_booking_field_type: 'Field Type',
    create_booking_surface: 'Surface',
    create_booking_capacity: 'Capacity',
    create_booking_amenities: 'Amenities',
    create_booking_no_amenities: 'No amenities listed for this field.',
    create_booking_submit: 'Create Booking',
    create_booking_submitting: 'Creating Booking...',
    create_booking_success: 'Booking created successfully!',
    create_booking_valid_datetime: 'Please provide a valid date and time',
    field_not_found: 'Field not found',
    field_not_found_description: 'The field may have been removed or the link is incorrect.',
    field_not_available: 'Not Available',
    field_request_access: 'Request Booking Access',
    field_overview: 'Overview',
    field_live_booking: 'Live Booking',
    field_comment_rate: 'Comment & Rate',
    field_about: 'About This Field',
    field_ready_description: 'This field is ready for bookings, team play, and regular matches.',
    field_name: 'Field Name',
    field_type: 'Field Type',
    field_surface_type: 'Surface Type',
    field_price_per_hour: 'Price Per Hour',
    field_discount: 'Discount',
    field_capacity: 'Capacity',
    field_status: 'Status',
    field_full_address: 'Full Address',
    field_address_not_specified: 'Address not specified',
    field_coordinates: 'Coordinates: {{lat}}, {{lng}}',
    field_location_map: 'Location Map',
    field_amenities: 'Amenities',
    field_live_schedule: 'Live Booking Schedule',
    field_live_schedule_subtitle: 'Visual schedule for this field only. See who is playing when.',
    field_select_day: 'Select Day',
    field_schedule: 'Field schedule',
    field_schedule_subtitle: 'Only this field is shown. Captains can book available slots.',
    field_available: 'Available',
    field_booked: 'Booked',
    field_available_slot: 'Available - click to book',
    field_available_open: 'Open for booking on this field.',
    field_reserved_slot: 'Reserved slot',
    field_pending_request: 'Pending request on this field.',
    field_confirmed_booking: 'Confirmed booking on this field.',
    field_reviews_coming: 'Reviews will appear here',
    field_reviews_placeholder: 'Field comments and rating submissions can be shown in this section after review data is connected for this page.',
    not_specified: 'Not specified',
    players_suffix: '{{count}} players',
    hour_suffix: '{{value}} hour',
    hours_suffix: '{{value}} hours',
    login_badge: 'Account Access',
    login_title: 'Sign In',
    login_description: 'Welcome back. Sign in to continue managing your bookings, teams, and football activity.',
    login_no_account: "Don't have an account?",
    login_create_one: 'Create one here',
    login_email_label: 'Email Address',
    login_email_placeholder: 'you@example.com',
    login_password_label: 'Password',
    login_password_placeholder: 'Password',
    login_hide_password: 'Hide password',
    login_show_password: 'Show password',
    login_remember_me: 'Remember me',
    login_forgot_password: 'Forgot password?',
    login_forgot_not_ready: 'Forgot password is not implemented yet.',
    login_not_available_title: 'Not Available Yet',
    login_signing_in: 'Signing in...',
    login_browse_first: 'Want to browse first?',
    login_continue_guest: 'Continue as guest',
    login_validation_email: 'Please enter your email address.',
    login_validation_password: 'Please enter your password.',
    register_badge: 'New Account',
    register_title: 'Create Account',
    register_description: 'Create your account to start booking fields, joining teams, or managing your venue with a clean and simple setup.',
    register_already_have_account: 'Already have an account?',
    register_sign_in: 'Sign in',
    register_first_name: 'First name',
    register_last_name: 'Last name',
    register_username: 'Username',
    register_phone: 'Phone',
    register_email: 'Email',
    register_password: 'Password',
    register_confirm_password: 'Confirm password',
    register_password_hint: 'Use at least 8 characters.',
    register_update_later: 'You can update your profile later',
    register_creating: 'Creating...',
    register_validation_first_name: 'Please enter your first name.',
    register_validation_last_name: 'Please enter your last name.',
    register_validation_username: 'Please enter your username.',
    register_validation_email: 'Please enter your email address.',
    register_validation_password: 'Please enter your password.',
    register_validation_confirm_password: 'Please confirm your password.',
    register_passwords_no_match: 'Passwords do not match.',
    settings_account_center: 'Account Center',
    settings_intro: 'This page now groups the things people usually expect in settings: account overview, device preferences, security, and access requests.',
    settings_preferences: 'Preferences',
    settings_preferences_desc: 'Small quality-of-life options that make the app feel more personal. These are saved on this device.',
    settings_local_only: 'Local only',
    settings_email_updates: 'Email updates',
    settings_email_updates_desc: 'Keep important account updates and approval decisions enabled.',
    settings_booking_reminders: 'Booking reminders',
    settings_booking_reminders_desc: 'Show reminders for upcoming bookings and pending field confirmations.',
    settings_match_alerts: 'Match and invite alerts',
    settings_match_alerts_desc: 'Prioritize team invites, join requests, and open match activity.',
    settings_compact_layout: 'Compact layout',
    settings_compact_layout_desc: 'Use tighter spacing for tables and content-heavy pages.',
    settings_language_desc: 'Change the interface language for this browser session.',
    settings_start_page: 'Default start page',
    settings_start_page_desc: 'Choose the first area you want to land on when you open the app.',
    settings_access_requests: 'Access Requests',
    settings_access_requests_desc: 'Upgrade your account when you need more control, like creating field bookings, team management, or field administration.',
    settings_request_history: 'Request History',
    settings_request_history_desc: 'A quick timeline of your previous access requests and their review status.',
    settings_security: 'Security',
    settings_security_desc: 'Keep your account protected and review the actions that affect sign-in.',
    settings_password: 'Password',
    settings_password_desc: 'Change your password any time if you shared a device, reused an old password, or just want a stronger one.',
    settings_change_password: 'Change Password',
    settings_current_account_role: 'Current account role',
    settings_last_review: 'Last settings review',
    settings_quick_links: 'Quick Links',
    settings_quick_links_desc: 'Shortcut actions people usually look for while managing their account.',
    settings_current_role: 'Current role',
    settings_captain_access: 'Captain Access',
    settings_captain_access_desc: 'Create field bookings, manage team members, approve join requests, and organize open matches.',
    settings_owner_access: 'Field Owner Access',
    settings_owner_access_desc: 'Create fields, manage booking requests, and control your venue schedule.',
    settings_member_since: 'Member since',
    settings_pending_requests: 'Pending requests',
    settings_available_upgrades: 'Available upgrades',
    settings_profile_details: 'Profile details',
    settings_profile_details_desc: 'Update your photo and personal information.',
    settings_notifications_desc: 'Review invites, alerts, and unread updates.',
    settings_pending_review: 'Pending review',
    settings_request_again: 'Request again',
    settings_request_role_button: 'Request {{role}}',
    settings_submitting: 'Submitting...',
    settings_deleting: 'Deleting...',
    settings_delete_request: 'Delete Request',
    settings_what_belongs: 'What belongs here?',
    settings_what_belongs_desc: 'Usually: security, notifications, app preferences, support, and role or permission requests. That structure is what this page now follows.',
    settings_change_password_desc: 'Enter your current password and choose a new one.',
    settings_close_password_form: 'Close change password form',
    settings_current_password: 'Current Password',
    settings_new_password: 'New Password',
    settings_confirm_new_password: 'Confirm New Password',
    settings_hide_current_password: 'Hide current password',
    settings_show_current_password: 'Show current password',
    settings_hide_new_password: 'Hide new password',
    settings_show_new_password: 'Show new password',
    settings_hide_password_confirmation: 'Hide password confirmation',
    settings_show_password_confirmation: 'Show password confirmation',
    settings_changing_password: 'Changing...',
    settings_save_password: 'Save Password',
    profile_admin: 'Admin Profile',
    profile_owner: 'Owner Profile',
    profile_account: 'Account Profile',
    profile_unknown_user: 'Unknown User',
    profile_guest: 'guest',
    profile_edit: 'Edit Profile',
    profile_remove_photo: 'Remove Photo',
    profile_admin_tools: 'Admin Tools',
    profile_admin_shortcuts: 'Administration Shortcuts',
    profile_admin_shortcuts_desc: 'Quick links for the areas you manage most often.',
    profile_manage_users_desc: 'Review and manage user accounts.',
    profile_role_requests_desc: 'Approve or reject access changes.',
    profile_account_status: 'Account Status',
    profile_active: 'active',
    profile_personal_info: 'Personal Information',
    profile_full_name: 'Full Name',
    profile_not_specified: 'Not specified',
    profile_dob: 'Date of Birth',
    profile_address: 'Address',
    profile_account_stats: 'Account Statistics',
    profile_total_bookings: 'Total Bookings',
    profile_current_teams: 'Current Teams',
    profile_no_teams: 'You are not in any team yet.',
    profile_no_home_field: 'No home field assigned',
    profile_members_count: '{{count}} members',
    profile_view_team: 'View team',
    profile_photo: 'Profile photo',
    profile_edit_message: 'Update your account information below.',
    profile_saving: 'Saving...',
    profile_save_changes: 'Save Changes',
    profile_enter_first_name: 'Enter first name',
    profile_enter_last_name: 'Enter last name',
    profile_enter_email: 'Enter email address',
    profile_phone_number: 'Phone Number',
    profile_enter_phone: 'Enter phone number',
    profile_gender: 'Gender',
    profile_gender_male: 'Male',
    profile_gender_female: 'Female',
    profile_gender_other: 'Other',
    profile_enter_address: 'Enter address',
    teams_all: 'All Teams',
    teams_my: 'My Teams',
    teams_admin_desc: 'Admin view of all teams. You can open or delete any team.',
    teams_my_desc: 'View your active teams and manage membership requests if you are a captain.',
    teams_results: '{{count}} results',
    teams_browse: 'Browse Teams',
    teams_hub_badge: 'Team Hub',
    teams_hub_desc: 'Track your squads, review pending invitations, and jump into team management without bouncing between pages.',
    teams_hub_admin_desc: 'Monitor every club on the platform, review activity, and step in when a team needs admin support.',
    teams_hub_active_teams: 'Active teams',
    teams_hub_workspace_single: 'Team in your workspace',
    teams_hub_workspace_plural: 'Teams in your workspace',
    teams_hub_pending_invites: 'Pending invites',
    teams_hub_need_response: 'Need your response',
    teams_hub_nothing_waiting: 'Nothing waiting right now',
    teams_hub_creation: 'Team creation',
    teams_hub_admin_access: 'Admin access',
    teams_hub_enabled: 'Enabled',
    teams_hub_ready: 'Ready',
    teams_hub_locked: 'Locked',
    teams_hub_create_desc: 'You can create a new squad',
    teams_hub_locked_desc: 'Captains and owners can create teams',
    teams_hub_admin_manage_desc: 'You can open or remove any team',
    teams_invitations: 'Team Invitations',
    teams_pending_count: '{{count}} pending',
    teams_invited_by: 'Invited by: {{name}}',
    teams_captain: 'Captain',
    teams_accept: 'Accept',
    teams_decline: 'Decline',
    teams_no_description: 'No description available.',
    teams_captain_label: 'Captain: {{name}}',
    teams_home_field: 'Home Field: {{name}}',
    teams_skill: 'Skill:',
    teams_jersey: 'Jersey:',
    teams_view_details: 'View Details',
    teams_delete: 'Delete',
    teams_skill_beginner: 'Beginner',
    teams_skill_intermediate: 'Intermediate',
    teams_skill_advanced: 'Advanced',
    teams_join_submitted: 'Join request submitted. Waiting for captain approval.',
    teams_join_still_pending: 'Your join request is still waiting for captain approval.',
    teams_none_found: 'No teams found',
    teams_none_found_desc: 'Browse teams to request to join, or create your own team if you are a captain.',
    teams_public_desc: 'Discover football teams and request to join.',
    teams_public_empty_desc: 'Check back later, or register as a captain to create a team.',
    teams_search_placeholder: 'Search teams, captains, or players...',
    teams_search_scope_all: 'All teams',
    teams_search_scope_captains: 'Captains',
    teams_search_scope_players: 'Players',
    teams_search_empty_desc: 'Try a different search or clear the filter to browse all public teams.',
    teams_request_pending: 'Request Pending',
    teams_request_join: 'Request Join',
    teams_your_team: 'Your Team',
    teams_login_to_join: 'Login to Join',
    teams_load_failed: 'Failed to load teams',
    teams_join_failed: 'Failed to submit join request',
    teams_accept_invite_failed: 'Failed to accept invitation',
    teams_decline_invite_failed: 'Failed to decline invitation',
    teams_delete_message_required: 'Please enter a message to captain before deleting.',
    teams_delete_success: 'Team deleted successfully.',
    teams_delete_failed: 'Failed to delete team',
    teams_delete_modal_title: 'Delete Team',
    teams_delete_modal_desc: 'Send a message to captain before deleting {{team}}.',
    teams_message_to_captain: 'Message to captain',
    teams_delete_reason_placeholder: 'Explain why this team is being deleted...',
    teams_send_delete: 'Send & Delete',
    teams_image: 'Team image',
    league_title: 'Football Leagues',
    league_subtitle: 'Live scores and standings',
    league_table: 'Table',
    league_loading: 'Loading league data...',
    league_yesterday: 'Yesterday',
    league_today: 'Today',
    league_tomorrow: 'Tomorrow',
    league_latest_matches: 'Latest Matches',
    league_no_matches_date: 'No matches for this date.',
    league_table_title: 'League Table',
    league_form: 'Form',
    league_full_time: 'Full Time',
    league_live: 'Live',
    league_postponed: 'Postponed',
    league_upcoming: 'Upcoming',
    landing_tomorrow: 'Tomorrow',
    landing_previous_hero_image: 'Previous hero image',
    landing_go_to_hero_image: 'Go to hero image {{count}}',
    landing_next_hero_image: 'Next hero image',
    landing_why_choose_us_title: 'Why Choose Us',
    landing_why_choose_us_subtitle: 'We make football field booking simple, secure, and convenient.',
    landing_easy_booking: 'Easy Booking',
    landing_easy_booking_desc: 'Reserve your field in just a few taps with a clear schedule.',
    landing_secure_payment: 'Secure Payment',
    landing_secure_payment_desc: 'Reliable and secure transactions for every booking.',
    landing_flexible_hours: 'Flexible Hours',
    landing_flexible_hours_desc: 'Choose from morning to night for casual games or competitive matches.',
    landing_best_prices: 'Best Prices',
    landing_best_prices_desc: 'Transparent pricing with competitive rates from field owners.',
    landing_team_friendly: 'Team Friendly',
    landing_team_friendly_desc: 'Create a team, invite players, and organize matches faster.',
    landing_premium_facilities: 'Premium Facilities',
    landing_premium_facilities_desc: 'Find fields with quality turf and useful amenities.',
    landing_how_it_works_title: 'How It Works',
    landing_how_it_works_subtitle: 'Book your football field in four simple steps.',
    landing_step_browse: 'Browse Fields',
    landing_step_browse_desc: 'View available football fields and compare different options.',
    landing_step_select: 'Select Date and Time',
    landing_step_select_desc: 'Choose the time that fits your team schedule.',
    landing_step_confirm: 'Confirm Booking',
    landing_step_confirm_desc: 'Send your request and get booking confirmation quickly.',
    landing_step_play: 'Play the Match',
    landing_step_play_desc: 'Show up, play, and enjoy your game.',
    landing_upgrade_badge: 'Upgrade Your Account',
    landing_upgrade_title: 'Grow From Player To Organizer Or Venue Owner',
    landing_upgrade_subtitle: 'Players can upgrade into business-ready roles with a one-time platform fee. Every upgrade includes admin review, stronger account permissions, and a clearer path to operating teams or fields professionally.',
    landing_upgrade_notice: 'Upgrade fees are charged once per role request and reviewed by admins after payment.',
    landing_one_time_upgrade_fee: 'One-time upgrade fee',
    landing_admin_approval_included: 'Admin approval included',
    landing_best_flow_upgrade: 'Best flow: pay the upgrade fee, submit your request in Settings, and wait for admin approval.',
    landing_upgrade_now: 'Upgrade Now',
    landing_call_for_demo: 'Call for Demo',
    landing_upgrade_captain_title: 'Captain Access',
    landing_upgrade_captain_description: 'Create bookings, lead your team, approve members, and unlock open-match coordination.',
    landing_upgrade_captain_benefit_1: 'Create team bookings',
    landing_upgrade_captain_benefit_2: 'Manage team membership',
    landing_upgrade_captain_benefit_3: 'Approve join requests',
    landing_upgrade_captain_benefit_4: 'Open and respond to matches',
    landing_upgrade_field_owner_title: 'Field Owner Access',
    landing_upgrade_field_owner_description: 'List venues, review booking requests, and manage your field business from an owner dashboard.',
    landing_upgrade_field_owner_benefit_1: 'Publish football fields',
    landing_upgrade_field_owner_benefit_2: 'Control venue schedules',
    landing_upgrade_field_owner_benefit_3: 'Review booking requests',
    landing_upgrade_field_owner_benefit_4: 'Track field operations',
    landing_world_class_facilities_title: 'World-Class Facilities',
    landing_world_class_facilities_subtitle: 'Every field comes equipped with premium amenities to enhance your playing experience',
    landing_premium_experience_title: 'Premium Experience Guaranteed',
    landing_premium_experience_subtitle: 'All our facilities are regularly maintained and sanitized. We ensure the highest standards of cleanliness and safety for all our customers. Every field is inspected daily and meets professional football standards.',
    landing_brand_name: 'Football Field Booking',
    landing_brand_tagline: 'Book football fields faster',
    landing_hero_badge: 'One search for players, captains, and fields',
    landing_hero_title: 'Find your favorite players, captains, and fields.',
    landing_hero_description: 'Search public teams, trusted captains, and available football fields before you book or request to join.',
    landing_hero_search_fields: 'Fields',
    landing_hero_search_captains: 'Captains',
    landing_hero_search_players: 'Players',
    landing_hero_search_placeholder_fields: 'Search field name, city, or surface',
    landing_hero_search_placeholder_captains: 'Search captain name, username, or team',
    landing_hero_search_placeholder_players: 'Search player name or public team',
    landing_hero_search_button: 'Search',
    landing_hero_search_hint: 'Start with a quick search, then jump straight to live fields or public teams.',
    landing_hero_browse_fields: 'Browse live fields',
    landing_hero_browse_teams: 'Explore teams, captains, and players',
    landing_featured_badge: 'Featured picks',
    landing_featured_title: 'Featured football fields',
    landing_featured_subtitle: 'Choose from highly rated football fields and see how other players review each one.',
    landing_live_fields_badge: 'Live field list',
    landing_live_fields_title: 'Fields you can book today',
    landing_live_fields_subtitle: 'Browse live football field options with pricing, location, and open booking times.',
    landing_live_availability: 'Live availability',
    landing_available_now: 'Available now',
    landing_no_slots_left: 'No slots left',
    landing_slots_left: '{{count}} slots left',
    landing_open_windows: '{{count}} open slots',
    landing_starting_price: 'Starting price',
    landing_sold_out: 'Sold out',
    landing_filling_fast: 'Filling fast',
    landing_ready_to_book: 'Ready to book',
    landing_quick_book: 'Quick book',
    landing_view_all_fields: 'View all available fields',
    landing_more_count: '24 more',
    landing_schedule_title: 'Live booking schedule',
    landing_schedule_subtitle: 'See every field booking time at a glance to know who is playing when.',
    landing_popular_sessions_badge: 'Popular play times',
    landing_popular_sessions_title: 'Popular sessions',
    landing_popular_sessions_subtitle: 'See which part of the day is busiest and choose the session that suits your team.',
    landing_session_morning: 'Morning session',
    landing_session_afternoon: 'Afternoon session',
    landing_session_evening: 'Evening session',
    landing_status_high_demand: 'High demand',
    landing_status_popular: 'Popular',
    landing_status_steady: 'Steady',
    landing_status_open: 'Open',
    landing_session_morning_desc: 'Cooler hours for teams that want an early start.',
    landing_session_afternoon_desc: 'Balanced daytime and after-work demand for flexible match schedules.',
    landing_session_evening_desc: 'Prime-time hours for busy matches under the lights.',
    landing_total_bookings: 'Total bookings',
    landing_active_fields: 'Active fields',
    landing_color_guide: 'Color guide',
    landing_your_booking: 'Your booking',
    landing_other_team_booked: 'Other team (booked)',
    landing_pending_bookable: 'Pending (still bookable)',
    landing_field_closed: 'Field closed',
    landing_time_field: 'Time / Field',
    landing_outdoor: 'Outdoor',
    landing_closed: 'Closed',
    landing_closed_by_owner: 'Closed by owner',
    landing_closure_reason_owner: 'The field owner has temporarily closed bookings for this field.',
    landing_closure_reason_maintenance: 'This field is currently under maintenance.',
    landing_closure_reason_unavailable: 'The field owner has marked this field as unavailable.',
    landing_closure_reason_default: 'Bookings for this field are temporarily unavailable.',
    landing_reopens_on: 'Reopens {{date}}',
    landing_your_booking_track: 'Your booking - click to track',
    landing_reason: 'Reason',
    landing_ratings_count: '{{count}} ratings',
    landing_rating_new: 'New',
    landing_minute_unit: 'min',
    landing_session_unit: 'session',
    landing_best_for: 'Best for:',
    landing_full_squads: 'Full squads',
    landing_quick_matches: 'Quick matches',
    landing_click_to_view_field: 'Click to view field',
    landing_pending_request: 'Pending request',
    landing_footer_about: 'A simple platform for discovering football venues, checking live availability, and booking the best session for your team.',
    landing_quick_links: 'Quick Links',
    landing_booking_info: 'Booking Info',
    landing_booking_info_1: 'Open daily for football sessions from 08:00 to 22:00.',
    landing_booking_info_2: 'Compare field ratings, prices, and available slots in one place.',
    landing_booking_info_3: 'Best for quick matches, team training, and full-squad games.',
    landing_contact: 'Contact',
    landing_contact_location: 'Phnom Penh, Cambodia',
    landing_footer_bottom: 'Football Field Booking helps players and teams book football fields with less hassle.',
    landing_discounts_badge: 'Live Field Discounts',
    landing_discounts_title: 'Special Deals & Discounts',
    landing_discounts_subtitle: 'Real discounts from field owners, updated from the current fields on the platform.',
    landing_discount_headline: '{{discount}} at {{field}}',
    landing_discount_description: 'Save {{amount}}/hour on this field in {{city}}.',
    landing_discount_summary_suffix: 'Book now before discounted slots fill up.',
    landing_discounts_empty_description: 'Field owners can add discounts and they will appear here automatically.',
    landing_no_live_offers: 'No live offers',
    landing_check_back_later: 'Check back later',
    landing_featured_city: 'Featured city',
    landing_discount_field_label: 'Field:',
    landing_discount_location_label: 'Location:',
    landing_book_discounted_field: 'Book Discounted Field',
    landing_no_active_discounts: 'No field discounts are active yet. When owners add discounts, this section will update automatically.',
    landing_discounts_coming_soon: 'Discounts Coming Soon',
    landing_book_this_discount: 'Book This Discount',
    landing_no_offer_yet: 'No Offer Yet',
    landing_original_price: 'Original Price',
    landing_discounted_price: 'Discounted Price',
    landing_facility_free_wifi_title: 'Free WiFi',
    landing_facility_free_wifi_description: 'High-speed internet available',
    landing_facility_free_parking_title: 'Free Parking',
    landing_facility_free_parking_description: 'Ample parking space',
    landing_facility_shower_rooms_title: 'Shower Rooms',
    landing_facility_shower_rooms_description: 'Clean changing facilities',
    landing_facility_cctv_security_title: 'CCTV Security',
    landing_facility_cctv_security_description: '24/7 surveillance',
    landing_facility_led_floodlights_title: 'LED Floodlights',
    landing_facility_led_floodlights_description: 'Professional lighting',
    landing_facility_cafeteria_title: 'Cafeteria',
    landing_facility_cafeteria_description: 'Snacks & beverages',
    landing_facility_first_aid_title: 'First Aid',
    landing_facility_first_aid_description: 'Medical assistance ready',
    landing_facility_air_conditioned_title: 'Air Conditioned',
    landing_facility_air_conditioned_description: 'Climate controlled rooms',
    landing_facility_water_stations_title: 'Water Stations',
    landing_facility_water_stations_description: 'Free drinking water',
    landing_facility_spectator_area_title: 'Spectator Area',
    landing_facility_spectator_area_description: 'Seating for supporters',
    landing_facility_equipment_rental_title: 'Equipment Rental',
    landing_facility_equipment_rental_description: 'Balls, bibs & gear',
    landing_facility_lounge_area_title: 'Lounge Area',
    landing_facility_lounge_area_description: 'Comfortable waiting space',
    landing_premium_daily_maintenance: 'Daily Maintenance',
    landing_premium_professional_standards: 'Professional Standards',
    landing_premium_safety_certified: 'Safety Certified',
    landing_premium_eco_friendly: 'Eco Friendly',
    owner_bookings_title: 'Booking requests',
    owner_bookings_subtitle: 'Confirm or cancel booking requests. Match completion is managed in Matches.',
    owner_bookings_load_failed: 'Failed to load booking requests',
    owner_bookings_select_date_first: 'Please select a date before accepting this booking.',
    owner_bookings_invalid_date: 'Unable to update booking date. Please choose a valid date.',
    owner_bookings_confirm_accept_message: 'Do you want to accept this booking request?',
    owner_bookings_confirm_cancel_message: 'Do you want to cancel booking?',
    owner_bookings_cancel_title: 'Cancel Booking',
    owner_bookings_update_failed: 'Failed to update booking',
    owner_bookings_cancellation_pending: 'Cancellation Pending',
    owner_bookings_booked: 'Booked',
    owner_bookings_booked_subtitle: 'Confirmed bookings ready for play.',
    owner_bookings_completed_subtitle: 'Finished matches recorded successfully.',
    owner_bookings_requests: 'Requests',
    owner_bookings_showing: 'Showing: {{status}}',
    owner_bookings_items: '{{count}} items',
    owner_bookings_empty_title: 'No bookings',
    owner_bookings_empty_description: 'Try another filter, or wait for new booking requests.',
    owner_bookings_home_team: 'Home Team',
    owner_bookings_away_team: 'Away Team',
    owner_bookings_result_recorded: 'Result recorded: {{home}} {{homeScore}} - {{awayScore}} {{away}}',
    owner_bookings_match_date: 'Match date',
    owner_bookings_accept: 'Accept Booking',
    owner_bookings_use_matches: 'Use Matches page to complete',
    owner_bookings_no_actions: 'No actions',
    owner_bookings_tip: 'Tip: Confirm pending requests quickly to improve your field booking rate.',
    owner_bookings_details_title: 'Booking details',
    owner_bookings_details_message: 'View the full booking information and manage the request.',
    owner_bookings_close: 'Close',
    owner_bookings_details_badge: 'Booking Details',
    owner_bookings_info: 'Booking Information',
    owner_bookings_date: 'Date',
    owner_bookings_start_time: 'Start Time',
    owner_bookings_end_time: 'End Time',
    owner_bookings_id: 'Booking ID',
    owner_bookings_captain_account: 'Captain Account',
    owner_bookings_captain_account_subtitle: 'Who created this booking',
    owner_bookings_no_team_assigned: 'No team assigned',
    owner_bookings_team_not_assigned: 'Team not assigned',
    owner_bookings_opponent_team: 'Opponent Team',
    owner_bookings_not_assigned_yet: 'Not assigned yet',
    owner_bookings_other_info: 'Other Information',
    owner_bookings_location_unavailable: 'Location details not available',
    owner_matches_subtitle: 'Confirmed team-vs-team matches. Open any card to update result.',
    owner_matches_load_failed: 'Failed to load matches',
    owner_matches_cards: 'Match Cards',
    owner_matches_count: '{{count}} matches',
    owner_matches_empty_title: 'No matches yet',
    owner_matches_empty_description: 'Matches appear here after bookings are confirmed with both teams.',
    owner_matches_home_team: 'Home Team',
    owner_matches_away_team: 'Away Team',
    owner_matches_final: 'Final',
    owner_matches_mvp_label: 'MVP: {{name}}',
    owner_matches_input_locked: 'Input is locked until this match is marked completed.',
    owner_matches_score_locked_mvp_available: 'Result editing is locked after 24 hours, but MVP can still be managed below.',
    owner_matches_save_result_then_mvp: 'Save the match result first, then set MVP.',
    owner_matches_confirm_completed: 'Confirm Match Completed',
    owner_matches_request_admin_change: 'Request Admin Change',
    owner_matches_result_form: 'Result Form',
    owner_matches_team_score: '{{team}} score',
    owner_matches_notes_optional: 'Match notes (optional)',
    owner_matches_mvp_player: 'MVP Player',
    owner_matches_select_one_player: 'Select one player',
    owner_matches_save_result_first_short: 'Save result first',
    owner_matches_player_team: '{{label}} ({{team}})',
    owner_matches_loading_players: 'Loading eligible players...',
    owner_matches_no_players: 'No eligible players found for MVP selection.',
    owner_matches_update_result: 'Update Result',
    owner_matches_save_result: 'Save Result',
    owner_matches_update_mvp: 'Update MVP',
    owner_matches_set_mvp: 'Set MVP',
    owner_matches_mark_completed_first: 'Mark booking as completed first.',
    owner_matches_showing: 'Showing {{visible}} of {{total}} matches',
    owner_matches_tip: 'Click any match card to open the result form.',
    owner_matches_no_admin: 'No admin account found to receive this request.',
    owner_matches_unknown_date: 'Unknown date',
    owner_matches_change_request_title: 'Match result change request',
    owner_matches_change_request_message: 'Owner requested admin review to change result for {{home}} vs {{away}} ({{when}}).',
    owner_matches_change_request_sent: 'Request sent to admin. They will review this match result change.',
    owner_matches_change_request_failed: 'Failed to send admin change request',
    owner_matches_result_after_completed: 'Result can only be entered after the match is completed.',
    owner_matches_edit_locked: 'Result editing is locked after 24 hours. Please request admin to change it.',
    owner_matches_enter_scores: 'Please enter both team scores.',
    owner_matches_scores_valid: 'Scores must be non-negative whole numbers.',
    owner_matches_save_result_failed: 'Failed to save result',
    owner_matches_mvp_after_completed: 'MVP can only be selected after the match is completed.',
    owner_matches_save_result_first: 'Please save the match result before selecting MVP.',
    owner_matches_choose_mvp: 'Please choose one player to set as MVP.',
    owner_matches_mvp_saved: 'MVP saved successfully.',
    owner_matches_save_mvp_failed: 'Failed to save MVP',
    owner_matches_mark_completed_failed: 'Failed to mark match as completed',
    dashboard_load_failed: 'Failed to load dashboard',
    dashboard_captain_overview_badge: 'Captain Overview',
    dashboard_captain_description: 'Manage your teams, approve join requests, and keep bookings under control.',
    dashboard_captained_teams: 'Captained Teams',
    dashboard_my_bookings: 'My Bookings',
    dashboard_fields_available: 'Fields Available',
    dashboard_next_booking: 'Next booking',
    dashboard_nothing_scheduled: 'Nothing scheduled',
    dashboard_create_booking_start: 'Create a booking to get started',
    dashboard_teams_managed: 'Teams managed',
    dashboard_active_captain_workspaces: 'Active captain workspaces',
    dashboard_create_or_captain_team: 'Create or captain a team',
    dashboard_join_queue: 'Join queue',
    dashboard_requests_waiting_review: 'Requests waiting for your review',
    dashboard_create_booking: 'Create booking',
    dashboard_reserve_field_team: 'Reserve a field for your team',
    dashboard_manage_teams: 'Manage teams',
    dashboard_review_members_requests: 'Review members and requests',
    dashboard_find_fields: 'Find fields',
    dashboard_browse_venues: 'Browse available venues',
    dashboard_pending_join_requests: 'Pending Join Requests',
    dashboard_pending_join_requests_desc: 'Keep team membership flowing by clearing request queues quickly.',
    dashboard_no_pending_requests: 'No pending requests',
    dashboard_join_requests_appear_here: 'When players request to join, they will appear here.',
    dashboard_recent_bookings: 'Recent Bookings',
    dashboard_recent_bookings_desc: 'Latest booking activity connected to your account.',
    dashboard_view_all: 'View all',
    dashboard_field_booking: 'Field booking',
    dashboard_no_recent_bookings: 'No recent bookings',
    dashboard_recent_bookings_appear: 'Once bookings are created, the latest activity will appear here.',
    dashboard_team_snapshot: 'Team Snapshot',
    dashboard_team_snapshot_desc: 'Quick view of the teams you lead and their pending workload.',
    dashboard_open_teams: 'Open teams',
    dashboard_captained_teams_small: 'Captained teams',
    dashboard_teams_actively_manage: 'Teams you actively manage',
    dashboard_pending_join_requests_small: 'Pending join requests',
    dashboard_players_waiting_decision: 'Players waiting for a decision',
    dashboard_captain_tip: 'Tip: clear join requests quickly to keep your squad ready for bookings and open matches.',
    open_matches_access_only: 'This feature is available for team captains and field owners only.',
    open_matches_load_failed: 'Failed to load open matches',
    open_matches_available_count: '{{count}} available',
    open_matches_need_team: 'You need at least one team where you are captain to request an open match.',
    open_matches_choose_team: 'Please choose a team before sending the request.',
    open_matches_request_success: 'Join request submitted successfully.',
    open_matches_request_failed: 'Failed to submit join request',
    open_matches_owner_team: 'Owner Team: {{name}}',
    open_matches_active_members: '{{count}} active members',
    open_matches_rate: 'Rate: {{rate}}/hr',
    open_matches_discount: '({{percent}}% off)',
    open_matches_pending_exists: 'You already have a pending request for this match.',
    open_matches_select_team: 'Select your team',
    open_matches_optional_message: 'Optional message',
    open_matches_your_jersey: 'Your Jersey',
    open_matches_sending: 'Sending...',
    open_matches_request_join: 'Request to Join',
    open_matches_empty_title: 'No open matches right now',
    open_matches_empty_description: 'Check again later for new matches opened by other captains.',
    notifications_mark_all_read: 'Mark all read',
    notifications_empty_title: 'No notifications yet.',
    notifications_approve_leave: 'Approve Leave',
    notifications_view_team: 'View Team',
    notifications_mark_read: 'Mark read',
    dashboard_player_overview_badge: 'Player Overview',
    dashboard_player_description: 'Track invitations, team activity, and your next bookings in one place.',
    dashboard_player_my_teams: 'My Teams',
    dashboard_player_invitations: 'Invitations',
    dashboard_player_team_bookings: 'Team Bookings',
    dashboard_player_upcoming: 'Upcoming',
    dashboard_player_next_match_day: 'Next match day',
    dashboard_player_no_upcoming_booking: 'No upcoming booking',
    dashboard_player_watch_activity: 'Watch for team activity and invites',
    dashboard_player_my_teams_small: 'My teams',
    dashboard_player_current_teams: 'Teams you currently belong to',
    dashboard_player_join_team_unlock: 'Join a team to unlock match activity',
    dashboard_player_open_invites: 'Open invites',
    dashboard_player_unread_invites: 'Unread team invitations',
    dashboard_player_view_bookings: 'View bookings',
    dashboard_player_see_upcoming_sessions: 'See your upcoming sessions',
    dashboard_player_explore_teams: 'Explore teams',
    dashboard_player_join_squad: 'Join a squad or manage memberships',
    dashboard_player_browse_fields: 'Browse fields',
    dashboard_player_discover_venues: 'Discover venues near you',
    dashboard_player_upcoming_bookings: 'Upcoming Bookings',
    dashboard_player_upcoming_bookings_desc: 'Your next confirmed or pending sessions in chronological order.',
    dashboard_player_browse_create_booking: 'Browse fields and create your next booking.',
    dashboard_player_book_field: 'Book a field',
    dashboard_player_team_activity: 'Team Activity',
    dashboard_player_team_activity_desc: 'Your current team footprint and invitation activity.',
    dashboard_player_joined_teams: 'Joined teams',
    dashboard_player_member_teams: 'Teams where you are currently a member',
    dashboard_player_pending_invitations: 'Pending invitations',
    dashboard_player_invites_waiting: 'Invites waiting for your response',
    dashboard_player_tip: 'Tip: accepting invitations and tracking bookings here gives you a faster path into upcoming matches.',
    dashboard_owner_app_view_badge: 'Field Owner App View',
    dashboard_owner_app_description: 'Use the app workspace to manage teams, review invitations, and create bookings as an owner.',
    dashboard_owner_reserve_field: 'Reserve a field while using the app workspace',
    dashboard_owner_join_manage_team: 'Join or manage team activity',
    dashboard_player_team_invitation_notifications: 'Team Invitation Notifications',
    dashboard_player_no_invitation_notifications: 'No invitation notifications',
    dashboard_player_invitation_notifications_desc: 'When captains invite you to teams, they will appear here.',
    dashboard_admin_pending_approvals: 'Pending approvals requiring admin action',
    dashboard_admin_latest_activity: 'Latest activity across the platform',
    dashboard_admin_review_role_requests: 'Review role requests',
    dashboard_admin_approve_access: 'Approve captain and owner access',
    dashboard_admin_manage_users: 'Manage users',
    dashboard_admin_inspect_members: 'Inspect platform members',
    dashboard_admin_check_bookings: 'Check bookings',
    dashboard_admin_monitor_bookings: 'Monitor booking activity',
    dashboard_admin_pending_role_requests: 'Pending Role Requests',
    dashboard_admin_recent_access_requests: 'Recent access requests that need review from the admin side.',
    dashboard_admin_review_all: 'Review All',
    dashboard_admin_no_pending_role_requests: 'No pending role requests',
    dashboard_admin_newest_users: 'Newest Users',
    dashboard_admin_active: 'Active',
    dashboard_admin_suspended: 'Suspended',
    dashboard_admin_no_users: 'No users found',
    dashboard_admin_users_appear: 'User accounts will appear here after registration.',
    dashboard_admin_latest_bookings: 'Latest Bookings',
    dashboard_admin_view_bookings: 'View Bookings',
    dashboard_admin_no_bookings: 'No bookings yet',
    dashboard_admin_bookings_appear: 'Recent bookings will appear here for quick admin review.',
    admin_users_badge: 'Admin Users',
    admin_users_subtitle: 'Update roles, account status, and remove users with a cleaner overview.',
    admin_users_total: 'Total',
    admin_users_admins: 'Admins',
    admin_users_tab_all: 'All users',
    admin_users_role_hint: 'Filter users by role so admins can review players, captains, and field owners faster.',
    admin_users_search_placeholder: 'Search username, email, or name',
    admin_users_all_roles: 'All roles',
    admin_users_all_statuses: 'All statuses',
    admin_users_sort_newest: 'Newest first',
    admin_users_sort_oldest: 'Oldest first',
    admin_users_sort_activity: 'Most active',
    admin_users_inactive: 'Inactive',
    admin_users_user: 'User',
    admin_users_email: 'Email',
    admin_users_role: 'Role',
    admin_users_status: 'Status',
    admin_users_actions: 'Actions',
    admin_users_showing: 'Showing {{start}}-{{end}} of {{total}} users',
    admin_users_prev_page: 'Previous',
    admin_users_next_page: 'Next',
    admin_users_loading: 'Loading users...',
    admin_users_none_found: 'No users found with current filters.',
    admin_users_load_failed: 'Failed to load users.',
    admin_users_delete_title: 'Delete User',
    admin_users_delete_confirm: 'Delete user @{{username}}? This cannot be undone.',
    admin_users_delete_success: 'User deleted successfully.',
    admin_users_delete_failed: 'Failed to delete user.',
    admin_users_details_failed: 'Failed to load user details.',
    admin_users_update_success: 'User updated successfully.',
    admin_users_update_failed: 'Failed to update user.',
    admin_role_requests_badge: 'Access Review',
    admin_role_requests_subtitle: 'Review captain and field owner access requests with the same dashboard card style.',
    admin_role_requests_total: 'Total',
    admin_role_requests_approved: 'Approved',
    admin_role_requests_rejected: 'Rejected',
    admin_role_requests_search: 'Search username, email, name, or role',
    admin_role_requests_load_failed: 'Failed to load role requests.',
    admin_role_requests_confirm: 'Are you sure you want to {{action}} this request?',
    admin_role_requests_approve: 'approve',
    admin_role_requests_reject: 'reject',
    admin_role_requests_approve_title: 'Approve Request',
    admin_role_requests_reject_title: 'Reject Request',
    admin_role_requests_request_approved: 'Request approved.',
    admin_role_requests_request_rejected: 'Request rejected.',
    admin_role_requests_review_failed: 'Failed to review request.',
    admin_role_requests_loading: 'Loading requests...',
    admin_role_requests_none_found: 'No role requests found.',
    admin_role_requests_requested_role: 'Requested role',
    admin_role_requests_upgrade_fee: 'Upgrade fee',
    admin_role_requests_payment: 'Payment',
    admin_role_requests_paid: 'paid',
    admin_role_requests_note: 'Note',
    admin_role_requests_submitted: 'Submitted',
    admin_role_requests_reviewed_by: 'Reviewed by {{user}} at {{date}}',
    admin_role_requests_processing: 'Processing...',
    admin_role_requests_user_details: 'User Details',
    admin_role_requests_view_account: 'View account information for @{{username}}.',
    admin_role_requests_no_email: 'No email',
    admin_role_requests_no_phone: 'No phone number',
    admin_role_requests_no_address: 'No address'
  },
  km: {
    app_name: 'ការកក់ទីលានបាល់ទាត់',
    nav_home: 'ទំព័រដើម',
    nav_fields: 'ទីលាន',
    nav_league: 'លីគ',
    nav_leagues: 'លីគ',
    nav_teams: 'ក្រុម',
    nav_login: 'ចូលគណនី',
    nav_register: 'ចុះឈ្មោះ',
    nav_dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    nav_bookings: 'ការកក់',
    nav_matches: 'ការប្រកួត',
    nav_open_matches: 'ការប្រកួតបើកចំហ',
    nav_profile: 'ប្រវត្តិរូប',
    nav_notifications: 'ការជូនដំណឹង',
    nav_analytics: 'វិភាគទិន្នន័យ',
    nav_my_fields: 'ទីលានរបស់ខ្ញុំ',
    nav_booking_requests: 'សំណើកក់',
    nav_manage_users: 'គ្រប់គ្រងអ្នកប្រើ',
    nav_role_requests: 'សំណើតួនាទី',
    nav_settings: 'ការកំណត់',
    action_logout: 'ចាកចេញ',
    action_go_dashboard: 'ទៅផ្ទាំងគ្រប់គ្រង',
    action_add_field: 'បន្ថែមទីលាន',
    action_review_requests: 'ពិនិត្យសំណើ',
    action_manage_fields: 'គ្រប់គ្រងទីលាន',
    action_go_to_requests: 'ទៅកាន់សំណើ',
    action_edit: '\u1780\u17c2\u1794\u17d2\u179a\u17c2',
    action_open_field: 'បើកទីលាន',
    action_close_field: 'បិទទីលាន',
    action_save: '\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780',
    action_confirm: 'យល់ព្រម',
    action_decline: 'បដិសេធ',
    action_cancel: 'បោះបង់',
    action_back: 'ត្រឡប់ក្រោយ',
    action_back_to_fields: 'ត្រឡប់ទៅទីលាន',
    action_back_to_bookings: 'ត្រឡប់ទៅការកក់',
    action_book_now: 'កក់ឥឡូវនេះ',
    action_open_settings: 'បើកការកំណត់',
    action_create_team: 'បង្កើតក្រុម',
    workspace_player: 'ផ្ទាំងអ្នកលេង និងកាពីតែន',
    workspace_owner: 'ផ្ទាំងម្ចាស់ទីលាន',
    label_workspace: 'កន្លែងការងារ',
    label_language: 'ភាសា',
    language_en: 'English',
    language_km: 'ខ្មែរ',
    role_user: 'អ្នកប្រើ',
    role_player: 'អ្នកលេង',
    role_captain: 'កាពីតែន',
    role_admin: 'អ្នកគ្រប់គ្រង',
    role_field_owner: 'ម្ចាស់ទីលាន',
    page_dashboard_subtitle: 'សង្ខេបសកម្មភាព និងព័ត៌មានថ្មីៗរបស់អ្នក',
    page_fields_subtitle: 'ស្វែងរក និងមើលទីលានបាល់ទាត់ដែលមាន',
    page_league_subtitle: 'តាមដានកាលវិភាគ លទ្ធផល និងតារាងចំណាត់ថ្នាក់',
    page_teams_subtitle: 'គ្រប់គ្រងក្រុម និងសំណើសមាជិកភាពរបស់អ្នក',
    page_bookings_subtitle: 'បង្កើត និងគ្រប់គ្រងការកក់ទីលានរបស់អ្នក',
    page_open_matches_subtitle: 'ស្វែងរក និងឆ្លើយតបការប្រកួតបើកចំហ',
    page_notifications_subtitle: 'ពិនិត្យការអញ្ជើញ និងបច្ចុប្បន្នភាពសំណើ',
    page_profile_subtitle: 'កែប្រែគណនី និងចំណង់ចំណូលចិត្តរបស់អ្នក',
    page_settings_subtitle: 'គ្រប់គ្រងការកំណត់គណនី និងសំណើតួនាទី',
    page_manage_users_subtitle: 'ផ្ទាំងគ្រប់គ្រងអ្នកប្រើសម្រាប់អ្នកគ្រប់គ្រង',
    page_role_requests_subtitle: 'ពិនិត្យសំណើសុំសិទ្ធិតួនាទីដែលកំពុងរង់ចាំ',
    owner_badge: 'ម្ចាស់ទីលាន',
    owner_dashboard_title: 'ផ្ទាំងម្ចាស់ទីលាន',
    owner_dashboard_subtitle: 'តាមដានទីលានរបស់អ្នក ពិនិត្យសំណើកក់ និងគ្រប់គ្រងកាលវិភាគបានងាយស្រួល។',
    owner_pending_title: 'សំណើកក់កំពុងរង់ចាំ',
    owner_pending_subtitle: 'យល់ព្រម ឬបដិសេធសំណើថ្មីៗពីក្រុម។',
    owner_pending_empty_title: 'មិនមានសំណើកក់កំពុងរង់ចាំ',
    owner_pending_empty_description: 'នៅពេលអ្នកលេងបង្កើតការកក់សម្រាប់ទីលានរបស់អ្នក វានឹងបង្ហាញនៅទីនេះ។',
    owner_upcoming_title: 'ការកក់ដែលបានយល់ព្រមខាងមុខ',
    owner_upcoming_subtitle: 'ការកក់បន្ទាប់របស់អ្នកបន្ទាប់ពីបានអនុម័ត។',
    owner_upcoming_empty_title: 'មិនមានការកក់ខាងមុខ',
    owner_upcoming_empty_description: 'យល់ព្រមសំណើកក់ដែលកំពុងរង់ចាំ ដើម្បីមើលកាលវិភាគខាងមុខ។',
    owner_my_fields_title: 'ទីលានរបស់ខ្ញុំ',
    owner_my_fields_subtitle: 'មើលទីលាន ភាពទំនេរ និងតម្លៃរបស់អ្នកបានភ្លាមៗ។',
    owner_fields_subtitle: 'មើលទីលាន ភាពទំនេរ និងតម្លៃរបស់អ្នកបានភ្លាមៗ។',
    owner_no_fields_title: 'មិនទាន់មានទីលាន',
    owner_no_fields_description: 'បង្កើតទីលានដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើមទទួលការកក់។',
    owner_fields_empty_description: 'បង្កើតទីលានដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើមទទួលការកក់។',
    fields_no_rating_yet: 'មិនទាន់មានការវាយតម្លៃ',
    field_ratings_count: '{{count}} ការវាយតម្លៃ',
    field_per_hour_short: 'ម៉ោង',
    owner_my_fields_subtitle: 'មើលទីតាំង ភាពទំនេរ និងតម្លៃរបស់ទីលានរបស់អ្នកភ្លាមៗ។',
    owner_no_fields_title: 'មិនទាន់មានទីលាន',
    owner_no_fields_description: 'បង្កើតទីលានដំបូងរបស់អ្នក ដើម្បីចាប់ផ្តើមទទួលសំណើកក់។',
    owner_completed_summary: 'ការកក់បានបញ្ចប់៖ {{count}}។ ប្រាក់ចំណូលប៉ាន់ស្មានរួមបញ្ចូលការកក់ដែលម្ចាស់ទីលានបានយល់ព្រម ទោះបីបោះបង់ពេលក្រោយក៏ដោយ។',
    owner_pending_count: '{{count}} កំពុងរង់ចាំ',
    owner_upcoming_count: '{{count}} ខាងមុខ',
    stat_my_fields: 'ទីលានរបស់ខ្ញុំ',
    stat_pending_requests: 'សំណើកំពុងរង់ចាំ',
    stat_confirmed: 'បានយល់ព្រម',
    stat_revenue_est: 'ប្រាក់ចំណូល (ប៉ាន់ស្មាន)',
    booking_status_confirmed: 'បានយល់ព្រម',
    common_all: 'ទាំងអស់',
    common_pending: 'កំពុងរង់ចាំ',
    common_confirmed: 'បានយល់ព្រម',
    common_completed: 'បានបញ្ចប់',
    common_cancelled: 'បានបោះបង់',
    common_loading: 'កំពុងផ្ទុក...',
    common_updating: 'កំពុងធ្វើបច្ចុប្បន្នភាព...',
    common_deleting: 'កំពុងលុប...',
    common_created: 'បានបង្កើត',
    common_unknown: 'មិនស្គាល់',
    fields_title: 'ទីលាន',
    fields_subtitle: 'ស្វែងរកទីលានបាល់ទាត់នៅជិតអ្នក។',
    fields_results: '{{count}} លទ្ធផល',
    fields_search: 'ស្វែងរក',
    fields_search_placeholder: 'ស្វែងរកទីលាន...',
    fields_filter_type: 'ប្រភេទទីលាន',
    fields_filter_surface: 'ប្រភេទផ្ទៃ',
    fields_filter_price: 'តម្លៃអតិបរមា/ម៉ោង',
    fields_all_types: 'គ្រប់ប្រភេទ',
    fields_all_surfaces: 'គ្រប់ផ្ទៃ',
    fields_no_rating: 'មិនទាន់មានការវាយតម្លៃ',
    fields_reviews: '{{count}} ការវាយតម្លៃ',
    fields_delete_title: 'លុបទីលាន',
    fields_message_to_owner: 'សារទៅកាន់ម្ចាស់ទីលាន',
    fields_clear_filters: 'សម្អាតតម្រង',
    fields_no_fields_found: 'រកមិនឃើញទីលាន',
    fields_adjust_filters: 'សូមសាកល្បងកែតម្រូវការស្វែងរក ឬតម្រងរបស់អ្នក។',
    fields_load_more: 'ផ្ទុកទីលានបន្ថែម',
    fields_delete_message: 'ផ្ញើសារទៅម្ចាស់ទីលាន មុនពេលលុប {{name}}។',
    fields_delete_reason_placeholder: 'ពន្យល់មូលហេតុដែលទីលាននេះត្រូវបានលុប...',
    fields_send_delete: 'ផ្ញើ និងលុប',
    fields_owner_label: 'ម្ចាស់៖',
    fields_delete_message_required: 'សូមបញ្ចូលសារទៅម្ចាស់ទីលាន មុនពេលលុប។',
    fields_load_failed: 'បរាជ័យក្នុងការផ្ទុកទីលាន',
    fields_delete_failed: 'បរាជ័យក្នុងការលុបទីលាន',
    fields_booking_access_required: 'ត្រូវការសិទ្ធិកក់ទីលាន។',
    fields_booking_access_title: 'សិទ្ធិកក់ទីលាន',
    fields_only_available: 'អាចកក់បានតែទីលានដែលមានស្ថានភាព "available" ប៉ុណ្ណោះ។',
    booking_title: 'ការកក់',
    booking_subtitle_manage: 'គ្រប់គ្រងការកក់ទីលានបាល់ទាត់របស់អ្នក',
    booking_subtitle_track: 'តាមដានការកក់របស់អ្នកនៅទីនេះ។',
    booking_new: 'ការកក់ថ្មី',
    booking_request_captain: 'ស្នើសុំសិទ្ធិកាពីតែន',
    booking_filter_status: 'ស្ថានភាព',
    booking_filter_opponent: 'ការប្រកួតគូប្រជែង',
    booking_open_for_opponents: 'បើកសម្រាប់គូប្រជែង',
    booking_not_open: 'មិនបើក',
    booking_cancel_confirm: 'តើអ្នកចង់បោះបង់ការកក់របស់អ្នកមែនទេ?',
    booking_cancel_title: 'បោះបង់ការកក់',
    booking_cancel_button: 'បោះបង់ការកក់',
    booking_complete: 'បញ្ចប់',
    booking_matched: 'បានផ្គូផ្គង',
    booking_join_requests: 'សំណើចូលរួម',
    booking_no_requests: 'មិនទាន់មានសំណើ។',
    booking_loading_requests: 'កំពុងផ្ទុកសំណើ...',
    booking_booked_by: 'កក់ដោយ',
    booking_unknown_field: 'មិនស្គាល់ទីលាន',
    booking_no_team: 'មិនមានក្រុម',
    booking_waiting_owner_approval: 'កំពុងរង់ចាំការយល់ព្រមពីម្ចាស់ទីលាន។ ម៉ោងនេះនៅតែបើករហូតដល់បានបញ្ជាក់។',
    booking_already_matched: 'បានផ្គូផ្គងរួចហើយ',
    booking_team_a: 'ក្រុម A',
    booking_cancelling_match: 'កំពុងបោះបង់ការប្រកួត...',
    booking_cancel_matched_opponent: 'បោះបង់គូប្រកួតដែលបានផ្គូផ្គង',
    booking_open_match: 'បើកការប្រកួត',
    booking_close_match: 'បិទការប្រកួត',
    booking_unknown_team: 'មិនស្គាល់ក្រុម',
    booking_unknown_captain: 'មិនស្គាល់ប្រធានក្រុម',
    booking_approve_join: 'យល់ព្រមឱ្យចូលរួម',
    booking_empty_title: 'មិនមានការកក់',
    booking_empty_create_first: 'បង្កើតការកក់ដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើម។',
    booking_empty_request_captain: 'សូមស្នើសុំសិទ្ធិកាពីតែននៅក្នុងការកំណត់។',
    booking_empty_filtered: 'មិនមានការកក់សម្រាប់តម្រងដែលបានជ្រើសរើស។',
    team_captain: 'ប្រធានក្រុម',
    create_booking_access_required: 'ត្រូវការសិទ្ធិ',
    create_booking_access_description: 'អ្នកត្រូវការសិទ្ធិកាពីតែន ម្ចាស់ទីលាន ឬអ្នកគ្រប់គ្រង ដើម្បីកក់ទីលាន។',
    create_booking_title: 'បង្កើតការកក់ថ្មី',
    create_booking_subtitle: 'កក់ទីលានបាល់ទាត់សម្រាប់ក្រុមរបស់អ្នក',
    create_booking_select_field: 'ជ្រើសរើសទីលាន *',
    create_booking_select_team: 'ជ្រើសរើសក្រុម *',
    create_booking_choose_field: 'ជ្រើសរើសទីលាន...',
    create_booking_choose_team: 'ជ្រើសរើសក្រុម...',
    create_booking_jersey_colors: 'ពណ៌អាវក្រុម',
    create_booking_need_team: 'អ្នកត្រូវការក្រុមមួយមុនពេលកក់។',
    create_booking_start_time: 'ម៉ោងចាប់ផ្តើម *',
    create_booking_duration: 'រយៈពេល *',
    create_booking_notes: 'កំណត់ចំណាំ',
    create_booking_notes_placeholder: 'បន្ថែមកំណត់ចំណាំអំពីការកក់...',
    create_booking_summary: 'សង្ខេបការកក់',
    create_booking_field: 'ទីលាន',
    create_booking_team: 'ក្រុម',
    create_booking_date_time: 'កាលបរិច្ឆេទ និងម៉ោង',
    create_booking_total_price: 'តម្លៃសរុប',
    create_booking_field_details: 'ព័ត៌មានទីលានសម្រាប់កាពីតែន',
    create_booking_field_type: 'ប្រភេទទីលាន',
    create_booking_surface: 'ផ្ទៃ',
    create_booking_capacity: 'ចំណុះ',
    create_booking_amenities: 'សេវាកម្មបន្ថែម',
    create_booking_no_amenities: 'មិនមានសេវាកម្មបន្ថែមសម្រាប់ទីលាននេះទេ។',
    create_booking_submit: 'បង្កើតការកក់',
    create_booking_submitting: 'កំពុងបង្កើតការកក់...',
    create_booking_success: 'បានបង្កើតការកក់ដោយជោគជ័យ!',
    create_booking_valid_datetime: 'សូមបញ្ចូលកាលបរិច្ឆេទ និងម៉ោងឱ្យត្រឹមត្រូវ',
    field_not_found: 'រកមិនឃើញទីលាន',
    field_not_found_description: 'ទីលាននេះអាចត្រូវបានលុប ឬតំណភ្ជាប់មិនត្រឹមត្រូវ។',
    field_not_available: 'មិនអាចប្រើបាន',
    field_request_access: 'ស្នើសុំសិទ្ធិកក់',
    field_overview: 'ទិដ្ឋភាពទូទៅ',
    field_live_booking: 'ការកក់ផ្ទាល់',
    field_comment_rate: 'មតិយោបល់ និងវាយតម្លៃ',
    field_about: 'អំពីទីលាននេះ',
    field_ready_description: 'ទីលាននេះរួចរាល់សម្រាប់ការកក់ ការលេងជាក្រុម និងការប្រកួតជាប្រចាំ។',
    field_name: 'ឈ្មោះទីលាន',
    field_type: 'ប្រភេទទីលាន',
    field_surface_type: 'ប្រភេទផ្ទៃ',
    field_price_per_hour: 'តម្លៃក្នុងមួយម៉ោង',
    field_discount: 'បញ្ចុះតម្លៃ',
    field_capacity: 'ចំណុះ',
    field_status: 'ស្ថានភាព',
    field_full_address: 'អាសយដ្ឋានពេញ',
    field_address_not_specified: 'មិនបានបញ្ជាក់អាសយដ្ឋាន',
    field_coordinates: 'កូអរដោនេ៖ {{lat}}, {{lng}}',
    field_location_map: 'ផែនទីទីតាំង',
    field_amenities: 'សេវាកម្មបន្ថែម',
    field_live_schedule: 'កាលវិភាគកក់ផ្ទាល់',
    field_live_schedule_subtitle: 'កាលវិភាគសម្រាប់ទីលាននេះប៉ុណ្ណោះ។ មើលថានរណាកំពុងលេងនៅម៉ោងណា។',
    field_select_day: 'ជ្រើសរើសថ្ងៃ',
    field_schedule: 'កាលវិភាគទីលាន',
    field_schedule_subtitle: 'បង្ហាញតែទីលាននេះប៉ុណ្ណោះ។ កាពីតែនអាចកក់ម៉ោងទំនេរបាន។',
    field_available: 'ទំនេរ',
    field_booked: 'បានកក់',
    field_available_slot: 'ទំនេរ - ចុចដើម្បីកក់',
    field_available_open: 'អាចកក់បានលើទីលាននេះ។',
    field_reserved_slot: 'ម៉ោងបានកក់',
    field_pending_request: 'មានសំណើកំពុងរង់ចាំលើទីលាននេះ។',
    field_confirmed_booking: 'មានការកក់ដែលបានយល់ព្រមលើទីលាននេះ។',
    field_reviews_coming: 'ការវាយតម្លៃនឹងបង្ហាញនៅទីនេះ',
    field_reviews_placeholder: 'មតិយោបល់ និងការវាយតម្លៃអំពីទីលានអាចបង្ហាញនៅផ្នែកនេះ បន្ទាប់ពីភ្ជាប់ទិន្នន័យរួច។',
    not_specified: 'មិនបានបញ្ជាក់',
    players_suffix: '{{count}} នាក់',
    hour_suffix: '{{value}} ម៉ោង',
    hours_suffix: '{{value}} ម៉ោង',
    login_badge: 'ចូលប្រើគណនី',
    login_title: 'ចូលគណនី',
    login_description: 'សូមស្វាគមន៍មកវិញ។ ចូលគណនីដើម្បីបន្តគ្រប់គ្រងការកក់ ក្រុម និងសកម្មភាពបាល់ទាត់របស់អ្នក។',
    login_no_account: 'មិនទាន់មានគណនីមែនទេ?',
    login_create_one: 'បង្កើតនៅទីនេះ',
    login_email_label: 'អ៊ីមែល',
    login_password_label: 'ពាក្យសម្ងាត់',
    login_remember_me: 'ចងចាំខ្ញុំ',
    login_forgot_password: 'ភ្លេចពាក្យសម្ងាត់?',
    login_forgot_not_ready: 'មុខងារភ្លេចពាក្យសម្ងាត់មិនទាន់មាននៅឡើយទេ។',
    login_not_available_title: 'មិនទាន់អាចប្រើបាន',
    login_signing_in: 'កំពុងចូលគណនី...',
    login_browse_first: 'ចង់មើលសិនទេ?',
    login_continue_guest: 'បន្តជាភ្ញៀវ',
    login_validation_email: 'សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នក។',
    login_validation_password: 'សូមបញ្ចូលពាក្យសម្ងាត់របស់អ្នក។',
    register_badge: 'គណនីថ្មី',
    register_title: 'បង្កើតគណនី',
    register_description: 'បង្កើតគណនីរបស់អ្នកដើម្បីចាប់ផ្តើមកក់ទីលាន ចូលរួមក្រុម ឬគ្រប់គ្រងទីលានរបស់អ្នកបានយ៉ាងងាយស្រួល។',
    register_already_have_account: 'មានគណនីរួចហើយ?',
    register_sign_in: 'ចូលគណនី',
    register_first_name: 'នាមខ្លួន',
    register_last_name: 'នាមត្រកូល',
    register_username: 'ឈ្មោះអ្នកប្រើ',
    register_phone: 'ទូរស័ព្ទ',
    register_email: 'អ៊ីមែល',
    register_password: 'ពាក្យសម្ងាត់',
    register_confirm_password: 'បញ្ជាក់ពាក្យសម្ងាត់',
    register_password_hint: 'ប្រើយ៉ាងហោចណាស់ 8 តួអក្សរ។',
    register_update_later: 'អ្នកអាចកែប្រែប្រវត្តិរូបនៅពេលក្រោយបាន',
    register_creating: 'កំពុងបង្កើត...',
    register_validation_first_name: 'សូមបញ្ចូលនាមខ្លួនរបស់អ្នក។',
    register_validation_last_name: 'សូមបញ្ចូលនាមត្រកូលរបស់អ្នក។',
    register_validation_username: 'សូមបញ្ចូលឈ្មោះអ្នកប្រើរបស់អ្នក។',
    register_validation_email: 'សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នក។',
    register_validation_password: 'សូមបញ្ចូលពាក្យសម្ងាត់របស់អ្នក។',
    register_validation_confirm_password: 'សូមបញ្ជាក់ពាក្យសម្ងាត់របស់អ្នក។',
    register_passwords_no_match: 'ពាក្យសម្ងាត់មិនត្រូវគ្នា។',
    settings_account_center: 'មជ្ឈមណ្ឌលគណនី',
    settings_intro: 'ទំព័រនេះបានរៀបចំអ្វីៗដែលអ្នកប្រើប្រាស់ជាទូទៅរំពឹងទុកនៅក្នុងការកំណត់ ដូចជា ទិដ្ឋភាពគណនី ចំណូលចិត្តឧបករណ៍ សុវត្ថិភាព និងសំណើសិទ្ធិ។',
    settings_preferences: 'ចំណូលចិត្ត',
    settings_preferences_desc: 'ជម្រើសតូចៗដែលធ្វើឱ្យការប្រើប្រាស់កម្មវិធីមានលក្ខណៈផ្ទាល់ខ្លួនជាងមុន។ ទិន្នន័យទាំងនេះត្រូវបានរក្សាទុកលើឧបករណ៍នេះ។',
    settings_local_only: 'តែក្នុងឧបករណ៍នេះ',
    settings_email_updates: 'ការអាប់ដេតតាមអ៊ីមែល',
    settings_email_updates_desc: 'បើកទទួលការអាប់ដេតសំខាន់ៗនៃគណនី និងលទ្ធផលសំណើ។',
    settings_booking_reminders: 'ការរំលឹកការកក់',
    settings_booking_reminders_desc: 'បង្ហាញការរំលឹកសម្រាប់ការកក់ខាងមុខ និងការបញ្ជាក់ទីលានដែលកំពុងរង់ចាំ។',
    settings_match_alerts: 'ការជូនដំណឹងការប្រកួត និងការអញ្ជើញ',
    settings_match_alerts_desc: 'ផ្តល់អាទិភាពដល់ការអញ្ជើញក្រុម សំណើចូលរួម និងសកម្មភាពប្រកួតបើកចំហ។',
    settings_compact_layout: 'ប្លង់តូចជាប់គ្នា',
    settings_compact_layout_desc: 'ប្រើគម្លាតតូចជាងមុនសម្រាប់តារាង និងទំព័រដែលមានមាតិកាច្រើន។',
    settings_language_desc: 'ប្តូរភាសាផ្ទៃមុខសម្រាប់កម្មវិធីក្នុងកម្មវិធីរុករកនេះ។',
    settings_start_page: 'ទំព័រចាប់ផ្តើមលំនាំដើម',
    settings_start_page_desc: 'ជ្រើសតំបន់ដំបូងដែលអ្នកចង់ឃើញពេលបើកកម្មវិធី។',
    settings_access_requests: 'សំណើសុំសិទ្ធិ',
    settings_access_requests_desc: 'ដំឡើងសិទ្ធិគណនីរបស់អ្នក នៅពេលអ្នកត្រូវការតួនាទីបន្ថែម ដូចជា ការកក់ទីលាន ការគ្រប់គ្រងក្រុម ឬការគ្រប់គ្រងទីលាន។',
    settings_request_history: 'ប្រវត្តិសំណើ',
    settings_request_history_desc: 'បង្ហាញសង្ខេបលឿនអំពីសំណើសិទ្ធិចាស់ៗ និងស្ថានភាពពិនិត្យរបស់វា។',
    settings_security: 'សុវត្ថិភាព',
    settings_security_desc: 'រក្សាគណនីរបស់អ្នកឱ្យមានសុវត្ថិភាព និងពិនិត្យសកម្មភាពដែលពាក់ព័ន្ធនឹងការចូលគណនី។',
    settings_password: 'ពាក្យសម្ងាត់',
    settings_password_desc: 'ប្តូរពាក្យសម្ងាត់បានគ្រប់ពេល ប្រសិនបើអ្នកចែករំលែកឧបករណ៍ ប្រើពាក្យសម្ងាត់ចាស់ ឬចង់បានពាក្យសម្ងាត់ខ្លាំងជាងមុន។',
    settings_change_password: 'ប្តូរពាក្យសម្ងាត់',
    settings_current_account_role: 'តួនាទីគណនីបច្ចុប្បន្ន',
    settings_last_review: 'ការពិនិត្យការកំណត់ចុងក្រោយ',
    settings_quick_links: 'ផ្លូវកាត់រហ័ស',
    settings_quick_links_desc: 'សកម្មភាពផ្លូវកាត់ដែលមនុស្សភាគច្រើនតែងស្វែងរកពេលគ្រប់គ្រងគណនី។',
    settings_current_role: 'តួនាទីបច្ចុប្បន្ន',
    settings_captain_access: 'សិទ្ធិកាពីតែន',
    settings_captain_access_desc: 'បង្កើតការកក់ទីលាន គ្រប់គ្រងសមាជិកក្រុម អនុម័តសំណើចូលរួម និងរៀបចំការប្រកួតបើកចំហ។',
    settings_owner_access: 'សិទ្ធិម្ចាស់ទីលាន',
    settings_owner_access_desc: 'បង្កើតទីលាន គ្រប់គ្រងសំណើកក់ និងគ្រប់គ្រងកាលវិភាគទីលានរបស់អ្នក។',
    settings_member_since: 'ជាសមាជិកតាំងពី',
    settings_pending_requests: 'សំណើកំពុងរង់ចាំ',
    settings_available_upgrades: 'សិទ្ធិបន្ថែមដែលអាចស្នើបាន',
    settings_profile_details: 'ព័ត៌មានប្រវត្តិរូប',
    settings_profile_details_desc: 'ធ្វើបច្ចុប្បន្នភាពរូបភាព និងព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នក។',
    settings_notifications_desc: 'ពិនិត្យការអញ្ជើញ ការជូនដំណឹង និងព័ត៌មានថ្មីដែលមិនទាន់អាន។',
    settings_pending_review: 'កំពុងរង់ចាំពិនិត្យ',
    settings_request_again: 'ស្នើម្តងទៀត',
    settings_request_role_button: 'ស្នើ {{role}}',
    settings_submitting: 'កំពុងផ្ញើ...',
    settings_deleting: 'កំពុងលុប...',
    settings_delete_request: 'លុបសំណើ',
    settings_what_belongs: 'អ្វីដែលគួរមាននៅទីនេះ?',
    settings_what_belongs_desc: 'ជាទូទៅមាន សុវត្ថិភាព ការជូនដំណឹង ចំណូលចិត្តកម្មវិធី ការគាំទ្រ និងសំណើសុំតួនាទី ឬសិទ្ធិ។ ទំព័រនេះឥឡូវធ្វើតាមរចនាសម្ព័ន្ធនោះ។',
    settings_change_password_desc: 'បញ្ចូលពាក្យសម្ងាត់បច្ចុប្បន្នរបស់អ្នក ហើយជ្រើសពាក្យសម្ងាត់ថ្មីមួយ។',
    settings_close_password_form: 'បិទទម្រង់ប្តូរពាក្យសម្ងាត់',
    settings_current_password: 'ពាក្យសម្ងាត់បច្ចុប្បន្ន',
    settings_new_password: 'ពាក្យសម្ងាត់ថ្មី',
    settings_confirm_new_password: 'បញ្ជាក់ពាក្យសម្ងាត់ថ្មី',
    settings_hide_current_password: 'លាក់ពាក្យសម្ងាត់បច្ចុប្បន្ន',
    settings_show_current_password: 'បង្ហាញពាក្យសម្ងាត់បច្ចុប្បន្ន',
    settings_hide_new_password: 'លាក់ពាក្យសម្ងាត់ថ្មី',
    settings_show_new_password: 'បង្ហាញពាក្យសម្ងាត់ថ្មី',
    settings_hide_password_confirmation: 'លាក់ការបញ្ជាក់ពាក្យសម្ងាត់',
    settings_show_password_confirmation: 'បង្ហាញការបញ្ជាក់ពាក្យសម្ងាត់',
    settings_changing_password: 'កំពុងប្តូរ...',
    settings_save_password: 'រក្សាទុកពាក្យសម្ងាត់',
    profile_admin: 'ប្រវត្តិរូបអ្នកគ្រប់គ្រង',
    profile_owner: 'ប្រវត្តិរូបម្ចាស់ទីលាន',
    profile_account: 'ប្រវត្តិរូបគណនី',
    profile_unknown_user: 'មិនស្គាល់អ្នកប្រើ',
    profile_guest: 'ភ្ញៀវ',
    profile_edit: 'កែប្រែប្រវត្តិរូប',
    profile_remove_photo: 'លុបរូបភាព',
    profile_admin_tools: 'ឧបករណ៍អ្នកគ្រប់គ្រង',
    profile_admin_shortcuts: 'ផ្លូវកាត់គ្រប់គ្រង',
    profile_admin_shortcuts_desc: 'តំណភ្ជាប់រហ័សសម្រាប់តំបន់ដែលអ្នកគ្រប់គ្រងញឹកញាប់បំផុត។',
    profile_manage_users_desc: 'ពិនិត្យ និងគ្រប់គ្រងគណនីអ្នកប្រើ។',
    profile_role_requests_desc: 'អនុម័ត ឬបដិសេធការផ្លាស់ប្តូរសិទ្ធិ។',
    profile_account_status: 'ស្ថានភាពគណនី',
    profile_active: 'សកម្ម',
    profile_personal_info: 'ព័ត៌មានផ្ទាល់ខ្លួន',
    profile_full_name: 'ឈ្មោះពេញ',
    profile_not_specified: 'មិនបានបញ្ជាក់',
    profile_dob: 'ថ្ងៃខែឆ្នាំកំណើត',
    profile_address: 'អាសយដ្ឋាន',
    profile_account_stats: 'ស្ថិតិគណនី',
    profile_total_bookings: 'ការកក់សរុប',
    profile_current_teams: 'ក្រុមបច្ចុប្បន្ន',
    profile_no_teams: 'អ្នកមិនទាន់ស្ថិតក្នុងក្រុមណាមួយទេ។',
    profile_no_home_field: 'មិនទាន់កំណត់ទីលានផ្ទះ',
    profile_members_count: '{{count}} សមាជិក',
    profile_view_team: 'មើលក្រុម',
    profile_photo: 'រូបភាពប្រវត្តិរូប',
    profile_edit_message: 'ធ្វើបច្ចុប្បន្នភាពព័ត៌មានគណនីរបស់អ្នកខាងក្រោម។',
    profile_saving: 'កំពុងរក្សាទុក...',
    profile_save_changes: 'រក្សាទុកការផ្លាស់ប្តូរ',
    profile_enter_first_name: 'បញ្ចូលនាមខ្លួន',
    profile_enter_last_name: 'បញ្ចូលនាមត្រកូល',
    profile_enter_email: 'បញ្ចូលអ៊ីមែល',
    profile_phone_number: 'លេខទូរស័ព្ទ',
    profile_enter_phone: 'បញ្ចូលលេខទូរស័ព្ទ',
    profile_gender: 'ភេទ',
    profile_gender_male: 'ប្រុស',
    profile_gender_female: 'ស្រី',
    profile_gender_other: 'ផ្សេងទៀត',
    profile_enter_address: 'បញ្ចូលអាសយដ្ឋាន',
    teams_all: 'ក្រុមទាំងអស់',
    teams_my: 'ក្រុមរបស់ខ្ញុំ',
    teams_admin_desc: 'ទិដ្ឋភាពអ្នកគ្រប់គ្រងសម្រាប់ក្រុមទាំងអស់។ អ្នកអាចបើកមើល ឬលុបក្រុមណាមួយក៏បាន។',
    teams_my_desc: 'មើលក្រុមសកម្មរបស់អ្នក និងគ្រប់គ្រងសំណើសមាជិក ប្រសិនបើអ្នកជាកាពីតែន។',
    teams_results: '{{count}} លទ្ធផល',
    teams_browse: 'រកមើលក្រុម',
    teams_hub_badge: 'មជ្ឈមណ្ឌលក្រុម',
    teams_hub_desc: 'តាមដានក្រុមរបស់អ្នក ពិនិត្យការអញ្ជើញកំពុងរង់ចាំ និងចូលទៅការគ្រប់គ្រងក្រុមបានយ៉ាងងាយស្រួល ដោយមិនបាច់ប្តូរទំព័រ។',
    teams_hub_admin_desc: 'តាមដានគ្រប់ក្រុមទាំងអស់នៅលើប្រព័ន្ធ ពិនិត្យសកម្មភាព និងចូលជួយនៅពេលក្រុមណាមួយត្រូវការការគាំទ្រពីអ្នកគ្រប់គ្រង។',
    teams_hub_active_teams: 'ក្រុមកំពុងសកម្ម',
    teams_hub_workspace_single: 'ក្រុមនៅក្នុងវេទិការបស់អ្នក',
    teams_hub_workspace_plural: 'ក្រុមនៅក្នុងវេទិការបស់អ្នក',
    teams_hub_pending_invites: 'ការអញ្ជើញកំពុងរង់ចាំ',
    teams_hub_need_response: 'ត្រូវការការឆ្លើយតបពីអ្នក',
    teams_hub_nothing_waiting: 'មិនមានអ្វីកំពុងរង់ចាំទេ',
    teams_hub_creation: 'ការបង្កើតក្រុម',
    teams_hub_admin_access: 'សិទ្ធិអ្នកគ្រប់គ្រង',
    teams_hub_enabled: 'បានបើក',
    teams_hub_ready: 'រួចរាល់',
    teams_hub_locked: 'បានចាក់សោ',
    teams_hub_create_desc: 'អ្នកអាចបង្កើតក្រុមថ្មីមួយ',
    teams_hub_locked_desc: 'កាពីតែន និងម្ចាស់ទីលានអាចបង្កើតក្រុម',
    teams_hub_admin_manage_desc: 'អ្នកអាចបើកមើល ឬលុបក្រុមណាមួយក៏បាន',
    teams_invitations: 'ការអញ្ជើញចូលក្រុម',
    teams_pending_count: '{{count}} កំពុងរង់ចាំ',
    teams_invited_by: 'បានអញ្ជើញដោយ: {{name}}',
    teams_captain: 'កាពីតែន',
    teams_accept: 'ទទួលយក',
    teams_decline: 'បដិសេធ',
    teams_no_description: 'មិនមានការពិពណ៌នា។',
    teams_captain_label: 'កាពីតែន: {{name}}',
    teams_home_field: 'ទីលានផ្ទះ: {{name}}',
    teams_skill: 'កម្រិត:',
    teams_jersey: 'អាវក្រុម:',
    teams_view_details: 'មើលព័ត៌មានលម្អិត',
    teams_delete: 'លុប',
    teams_skill_beginner: 'កម្រិតដំបូង',
    teams_skill_intermediate: 'មធ្យម',
    teams_skill_advanced: 'ខ្ពស់',
    teams_join_submitted: 'បានផ្ញើសំណើចូលរួម។ កំពុងរង់ចាំការអនុម័តពីកាពីតែន។',
    teams_join_still_pending: 'សំណើចូលរួមរបស់អ្នកនៅតែកំពុងរង់ចាំការអនុម័តពីកាពីតែន។',
    teams_none_found: 'រកមិនឃើញក្រុម',
    teams_none_found_desc: 'ស្វែងរកក្រុមដើម្បីស្នើចូលរួម ឬបង្កើតក្រុមផ្ទាល់ខ្លួន ប្រសិនបើអ្នកជាកាពីតែន។',
    teams_public_desc: 'ស្វែងរកក្រុមបាល់ទាត់ និងស្នើសុំចូលរួម។',
    teams_public_empty_desc: 'សូមត្រឡប់មកមើលពេលក្រោយ ឬចុះឈ្មោះជាកាពីតែនដើម្បីបង្កើតក្រុម។',
    teams_search_placeholder: 'ស្វែងរកក្រុម កាពីតែន ឬអ្នកលេង...',
    teams_search_scope_all: 'គ្រប់ក្រុម',
    teams_search_scope_captains: 'កាពីតែន',
    teams_search_scope_players: 'អ្នកលេង',
    teams_search_empty_desc: 'សូមសាកល្បងពាក្យស្វែងរកផ្សេង ឬលុបតម្រង ដើម្បីមើលក្រុមសាធារណៈទាំងអស់។',
    teams_request_pending: 'សំណើកំពុងរង់ចាំ',
    teams_request_join: 'ស្នើចូលរួម',
    teams_your_team: 'ក្រុមរបស់អ្នក',
    teams_login_to_join: 'ចូលគណនីដើម្បីចូលរួម',
    teams_load_failed: 'បរាជ័យក្នុងការផ្ទុកក្រុម',
    teams_join_failed: 'បរាជ័យក្នុងការផ្ញើសំណើចូលរួម',
    teams_accept_invite_failed: 'បរាជ័យក្នុងការទទួលយកការអញ្ជើញ',
    teams_decline_invite_failed: 'បរាជ័យក្នុងការបដិសេធការអញ្ជើញ',
    teams_delete_message_required: 'សូមបញ្ចូលសារទៅកាពីតែន មុនពេលលុប។',
    teams_delete_success: 'បានលុបក្រុមដោយជោគជ័យ។',
    teams_delete_failed: 'បរាជ័យក្នុងការលុបក្រុម',
    teams_delete_modal_title: 'លុបក្រុម',
    teams_delete_modal_desc: 'ផ្ញើសារទៅកាពីតែន មុនពេលលុប {{team}}។',
    teams_message_to_captain: 'សារទៅកាពីតែន',
    teams_delete_reason_placeholder: 'ពន្យល់មូលហេតុដែលក្រុមនេះត្រូវបានលុប...',
    teams_send_delete: 'ផ្ញើ និងលុប',
    teams_image: 'រូបភាពក្រុម',
    league_title: 'លីគបាល់ទាត់',
    league_subtitle: 'ពិន្ទុផ្ទាល់ និងតារាងចំណាត់ថ្នាក់',
    league_table: 'តារាង',
    league_loading: 'កំពុងផ្ទុកទិន្នន័យលីគ...',
    league_yesterday: 'ម្សិលមិញ',
    league_today: 'ថ្ងៃនេះ',
    league_tomorrow: 'ស្អែក',
    league_latest_matches: 'ការប្រកួតចុងក្រោយ',
    league_no_matches_date: 'មិនមានការប្រកួតសម្រាប់ថ្ងៃនេះទេ។',
    league_table_title: 'តារាងលីគ',
    league_form: 'ទម្រង់',
    league_full_time: 'ចប់ការប្រកួត',
    league_live: 'កំពុងផ្សាយផ្ទាល់',
    league_postponed: 'ពន្យារពេល',
    league_upcoming: 'ខាងមុខ'
    ,
    landing_tomorrow: 'ស្អែក',
    landing_previous_hero_image: 'រូបភាពមុន',
    landing_go_to_hero_image: 'ទៅរូបភាពទី {{count}}',
    landing_next_hero_image: 'រូបភាពបន្ទាប់',
    landing_why_choose_us_title: 'ហេតុអ្វីជ្រើសរើសយើង',
    landing_why_choose_us_subtitle: 'យើងធ្វើឱ្យការកក់ទីលានបាល់ទាត់មានភាពងាយស្រួល សុវត្ថិភាព និងស្រួលប្រើ។',
    landing_easy_booking: 'ការកក់ងាយស្រួល',
    landing_easy_booking_desc: 'កក់ទីលានរបស់អ្នកបានត្រឹមប៉ុន្មានចុចជាមួយកាលវិភាគច្បាស់លាស់។',
    landing_secure_payment: 'ការទូទាត់មានសុវត្ថិភាព',
    landing_secure_payment_desc: 'ប្រតិបត្តិការទូទាត់ដែលអាចទុកចិត្តបាន និងមានសុវត្ថិភាពសម្រាប់ការកក់នីមួយៗ។',
    landing_flexible_hours: 'ម៉ោងបត់បែនបាន',
    landing_flexible_hours_desc: 'ជ្រើសរើសបានចាប់ពីព្រឹកដល់យប់ សម្រាប់ការលេងធម្មតា ឬការប្រកួតប្រជែង។',
    landing_best_prices: 'តម្លៃល្អបំផុត',
    landing_best_prices_desc: 'តម្លៃច្បាស់លាស់ជាមួយអត្រាប្រកួតប្រជែងពីម្ចាស់ទីលាន។',
    landing_team_friendly: 'សមស្របសម្រាប់ក្រុម',
    landing_team_friendly_desc: 'បង្កើតក្រុម អញ្ជើញអ្នកលេង និងរៀបចំការប្រកួតបានលឿនជាងមុន។',
    landing_premium_facilities: 'បរិក្ខារល្អប្រណិត',
    landing_premium_facilities_desc: 'ស្វែងរកទីលានដែលមានស្មៅគុណភាពល្អ និងសេវាកម្មមានប្រយោជន៍។',
    landing_how_it_works_title: 'របៀបដំណើរការ',
    landing_how_it_works_subtitle: 'កក់ទីលានបាល់ទាត់របស់អ្នកតាម ៤ ជំហានងាយៗ។',
    landing_step_browse: 'ស្វែងរកទីលាន',
    landing_step_browse_desc: 'មើលទីលានបាល់ទាត់ដែលអាចកក់បាន និងប្រៀបធៀបជម្រើសផ្សេងៗ។',
    landing_step_select: 'ជ្រើសរើសថ្ងៃ និងម៉ោង',
    landing_step_select_desc: 'ជ្រើសរើសម៉ោងដែលសមស្របនឹងកាលវិភាគក្រុមរបស់អ្នក។',
    landing_step_confirm: 'បញ្ជាក់ការកក់',
    landing_step_confirm_desc: 'ផ្ញើសំណើរបស់អ្នក ហើយទទួលបានការបញ្ជាក់ការកក់យ៉ាងឆាប់រហ័ស។',
    landing_step_play: 'ចូលលេងការប្រកួត',
    landing_step_play_desc: 'មកដល់លេង និងរីករាយជាមួយការប្រកួតរបស់អ្នក។',
    landing_upgrade_badge: 'ដំឡើងគណនី',
    landing_upgrade_title: 'អភិវឌ្ឍពីអ្នកលេងទៅជាអ្នករៀបចំ ឬម្ចាស់ទីលាន',
    landing_upgrade_subtitle: 'អ្នកលេងអាចដំឡើងទៅជាតួនាទីអាជីវកម្មដោយបង់ថ្លៃម្តង។ ការដំឡើងនីមួយៗរួមមានការពិនិត្យពីអ្នកគ្រប់គ្រង សិទ្ធិគណនីកាន់តែច្បាស់ និងផ្លូវការងារល្អសម្រាប់គ្រប់គ្រងក្រុម ឬទីលាន។',
    landing_upgrade_notice: 'ថ្លៃដំឡើងត្រូវបានគិតម្តងសម្រាប់សំណើតួនាទីនីមួយៗ ហើយអ្នកគ្រប់គ្រងនឹងពិនិត្យបន្ទាប់ពីការទូទាត់។',
    landing_one_time_upgrade_fee: 'ថ្លៃដំឡើងម្តង',
    landing_admin_approval_included: 'រួមបញ្ចូលការអនុម័តពីអ្នកគ្រប់គ្រង',
    landing_best_flow_upgrade: 'លំហូរល្អបំផុត៖ បង់ថ្លៃដំឡើង ដាក់សំណើនៅក្នុង Settings ហើយរង់ចាំការអនុម័តពីអ្នកគ្រប់គ្រង។',
    landing_upgrade_now: 'ដំឡើងឥឡូវ',
    landing_call_for_demo: 'ស្នើសុំការបង្ហាញ',
    landing_upgrade_captain_title: 'សិទ្ធិកាពីតែន',
    landing_upgrade_captain_description: 'បង្កើតការកក់ ដឹកនាំក្រុម អនុម័តសមាជិក និងបើកការសម្របសម្រួលការប្រកួត។',
    landing_upgrade_captain_benefit_1: 'បង្កើតការកក់សម្រាប់ក្រុម',
    landing_upgrade_captain_benefit_2: 'គ្រប់គ្រងសមាជិកក្រុម',
    landing_upgrade_captain_benefit_3: 'អនុម័តសំណើចូលរួម',
    landing_upgrade_captain_benefit_4: 'បើក និងឆ្លើយតបការប្រកួត',
    landing_upgrade_field_owner_title: 'សិទ្ធិម្ចាស់ទីលាន',
    landing_upgrade_field_owner_description: 'ដាក់បង្ហាញទីលាន ពិនិត្យសំណើកក់ និងគ្រប់គ្រងអាជីវកម្មទីលានរបស់អ្នកពីផ្ទាំងម្ចាស់ទីលាន។',
    landing_upgrade_field_owner_benefit_1: 'បោះផ្សាយទីលានបាល់ទាត់',
    landing_upgrade_field_owner_benefit_2: 'គ្រប់គ្រងកាលវិភាគទីលាន',
    landing_upgrade_field_owner_benefit_3: 'ពិនិត្យសំណើកក់',
    landing_upgrade_field_owner_benefit_4: 'តាមដានប្រតិបត្តិការទីលាន',
    landing_world_class_facilities_title: 'សេវាកម្មកម្រិតខ្ពស់',
    landing_world_class_facilities_subtitle: 'ទីលាននីមួយៗមានបរិក្ខារគុណភាពខ្ពស់ដើម្បីបង្កើនបទពិសោធន៍លេងរបស់អ្នក',
    landing_premium_experience_title: 'ធានាបទពិសោធន៍ល្អឥតខ្ចោះ',
    landing_premium_experience_subtitle: 'បរិក្ខាររបស់យើងត្រូវបានថែទាំ និងសម្អាតជាប្រចាំ។ យើងធានាស្តង់ដារខ្ពស់បំផុតក្នុងភាពស្អាត និងសុវត្ថិភាពសម្រាប់អតិថិជនទាំងអស់។ ទីលាននីមួយៗត្រូវបានត្រួតពិនិត្យរៀងរាល់ថ្ងៃ និងបំពេញតាមស្តង់ដារបាល់ទាត់វិជ្ជាជីវៈ។',
    landing_brand_name: 'ការកក់ទីលានបាល់ទាត់',
    landing_brand_tagline: 'កក់ទីលានបាល់ទាត់បានលឿនជាងមុន',
    landing_hero_badge: 'ស្វែងរកអ្នកលេង កាពីតែន និងទីលានបានក្នុងកន្លែងតែមួយ',
    landing_hero_title: 'ស្វែងរកអ្នកលេង កាពីតែន និងទីលានដែលអ្នកចូលចិត្ត។',
    landing_hero_description: 'ស្វែងរកក្រុមសាធារណៈ កាពីតែនដែលអាចទុកចិត្តបាន និងទីលានបាល់ទាត់ដែលអាចកក់បាន មុនពេលអ្នកកក់ ឬស្នើចូលរួម។',
    landing_hero_search_fields: 'ទីលាន',
    landing_hero_search_captains: 'កាពីតែន',
    landing_hero_search_players: 'អ្នកលេង',
    landing_hero_search_placeholder_fields: 'ស្វែងរកឈ្មោះទីលាន ទីក្រុង ឬប្រភេទផ្ទៃទីលាន',
    landing_hero_search_placeholder_captains: 'ស្វែងរកឈ្មោះកាពីតែន username ឬក្រុម',
    landing_hero_search_placeholder_players: 'ស្វែងរកឈ្មោះអ្នកលេង ឬក្រុមសាធារណៈ',
    landing_hero_search_button: 'ស្វែងរក',
    landing_hero_search_hint: 'ចាប់ផ្តើមដោយការស្វែងរករហ័ស ហើយចូលទៅកាន់ទីលានផ្ទាល់ ឬក្រុមសាធារណៈភ្លាមៗ។',
    landing_hero_browse_fields: 'មើលទីលានដែលអាចកក់បាន',
    landing_hero_browse_teams: 'ស្វែងរកក្រុម កាពីតែន និងអ្នកលេង',
    landing_featured_badge: 'ទីលានណែនាំ',
    landing_featured_title: 'ទីលានបាល់ទាត់ណែនាំ',
    landing_featured_subtitle: 'ជ្រើសរើសពីទីលានបាល់ទាត់ដែលមានការវាយតម្លៃខ្ពស់ និងមើលមតិរបស់អ្នកលេងផ្សេងទៀតសម្រាប់ទីលាននីមួយៗ។',
    landing_live_fields_badge: 'បញ្ជីទីលានផ្ទាល់',
    landing_live_fields_title: 'ទីលានដែលអ្នកអាចកក់ថ្ងៃនេះ',
    landing_live_fields_subtitle: 'ស្វែងរកជម្រើសទីលានបាល់ទាត់ផ្ទាល់ជាមួយតម្លៃ ទីតាំង និងម៉ោងកក់ដែលនៅទំនេរ។',
    landing_live_availability: 'ភាពទំនេរផ្ទាល់',
    landing_available_now: 'អាចកក់បានឥឡូវ',
    landing_no_slots_left: 'មិនមានម៉ោងទំនេរទៀតទេ',
    landing_slots_left: 'នៅសល់ {{count}} ម៉ោង',
    landing_open_windows: '{{count}} ម៉ោងទំនេរ',
    landing_starting_price: 'តម្លៃចាប់ផ្តើម',
    landing_sold_out: 'អស់កន្លែង',
    landing_filling_fast: 'កំពុងពេញលឿន',
    landing_ready_to_book: 'រួចរាល់សម្រាប់កក់',
    landing_quick_book: 'កក់រហ័ស',
    landing_view_all_fields: 'មើលទីលានទំនេរទាំងអស់',
    landing_more_count: '24 ទៀត',
    landing_schedule_title: 'កាលវិភាគកក់ផ្ទាល់',
    landing_schedule_subtitle: 'មើលម៉ោងកក់ទីលានទាំងអស់បានភ្លាមៗ ដើម្បីដឹងថានរណាកំពុងលេងនៅម៉ោងណា។',
    landing_popular_sessions_badge: 'ម៉ោងលេងពេញនិយម',
    landing_popular_sessions_title: 'វគ្គពេញនិយម',
    landing_popular_sessions_subtitle: 'មើលថាតើពេលណាក្នុងមួយថ្ងៃមានអ្នកកក់ច្រើនជាងគេ ហើយជ្រើសរើសវគ្គដែលសមស្របសម្រាប់ក្រុមរបស់អ្នក។',
    landing_session_morning: 'វគ្គព្រឹក',
    landing_session_afternoon: 'វគ្គរសៀល',
    landing_session_evening: 'វគ្គល្ងាច',
    landing_status_high_demand: 'តម្រូវការខ្ពស់',
    landing_status_popular: 'ពេញនិយម',
    landing_status_steady: 'ថេរ',
    landing_status_open: 'បើក',
    landing_session_morning_desc: 'ម៉ោងត្រជាក់សម្រាប់ក្រុមដែលចង់ចាប់ផ្តើមពីព្រឹក។',
    landing_session_afternoon_desc: 'តុល្យភាពល្អសម្រាប់ម៉ោងថ្ងៃ និងក្រោយម៉ោងការងារ សមស្របសម្រាប់ការប្រកួតដែលអាចបត់បែនបាន។',
    landing_session_evening_desc: 'ម៉ោងពេញនិយមសម្រាប់ការប្រកួតក្រោមភ្លើងនៅពេលល្ងាច។',
    landing_total_bookings: 'ការកក់សរុប',
    landing_active_fields: 'ទីលានសកម្ម',
    landing_color_guide: 'ការណែនាំពណ៌',
    landing_your_booking: 'ការកក់របស់អ្នក',
    landing_other_team_booked: 'ក្រុមផ្សេង (បានកក់)',
    landing_pending_bookable: 'កំពុងរង់ចាំ (នៅតែកក់បាន)',
    landing_field_closed: 'ទីលានបានបិទ',
    landing_time_field: 'ម៉ោង / ទីលាន',
    landing_outdoor: 'ក្រៅដំបូល',
    landing_closed: 'បានបិទ',
    landing_closed_by_owner: 'បិទដោយម្ចាស់ទីលាន',
    landing_closure_reason_owner: 'ម្ចាស់ទីលានបានបិទការកក់សម្រាប់ទីលាននេះជាបណ្តោះអាសន្ន។',
    landing_closure_reason_maintenance: 'ទីលាននេះកំពុងស្ថិតក្នុងការថែទាំ។',
    landing_closure_reason_unavailable: 'ម្ចាស់ទីលានបានកំណត់ឲ្យទីលាននេះមិនអាចប្រើបាន។',
    landing_closure_reason_default: 'ការកក់សម្រាប់ទីលាននេះមិនអាចប្រើបានជាបណ្តោះអាសន្ន។',
    landing_reopens_on: 'បើកវិញ {{date}}',
    landing_your_booking_track: 'ការកក់របស់អ្នក - ចុចដើម្បីតាមដាន',
    landing_reason: 'មូលហេតុ',
    landing_ratings_count: '{{count}} ការវាយតម្លៃ',
    landing_rating_new: 'ថ្មី',
    landing_minute_unit: 'នាទី',
    landing_session_unit: 'វគ្គ',
    landing_best_for: 'សមស្របសម្រាប់៖',
    landing_full_squads: 'ក្រុមពេញ',
    landing_quick_matches: 'ការប្រកួតរហ័ស',
    landing_click_to_view_field: 'ចុចដើម្បីមើលទីលាន',
    landing_pending_request: 'សំណើកំពុងរង់ចាំ',
    landing_footer_about: 'វេទិកាងាយស្រួលសម្រាប់ស្វែងរកទីលានបាល់ទាត់ ពិនិត្យភាពទំនេរផ្ទាល់ និងកក់វគ្គល្អបំផុតសម្រាប់ក្រុមរបស់អ្នក។',
    landing_quick_links: 'តំណរហ័ស',
    landing_booking_info: 'ព័ត៌មានកក់',
    landing_booking_info_1: 'បើករាល់ថ្ងៃសម្រាប់វគ្គបាល់ទាត់ពីម៉ោង 08:00 ដល់ 22:00។',
    landing_booking_info_2: 'ប្រៀបធៀបការវាយតម្លៃទីលាន តម្លៃ និងម៉ោងទំនេរ នៅកន្លែងតែមួយ។',
    landing_booking_info_3: 'ល្អសម្រាប់ការប្រកួតរហ័ស ការហ្វឹកហាត់ក្រុម និងការប្រកួតក្រុមពេញ។',
    landing_contact: 'ទំនាក់ទំនង',
    landing_contact_location: 'ភ្នំពេញ កម្ពុជា',
    landing_footer_bottom: 'ការកក់ទីលានបាល់ទាត់ជួយអ្នកលេង និងក្រុមកក់ទីលានបានងាយស្រួលជាងមុន។',
    landing_discounts_badge: 'បញ្ចុះតម្លៃទីលានផ្ទាល់',
    landing_discounts_title: 'ប្រម៉ូសិន និងការបញ្ចុះតម្លៃពិសេស',
    landing_discounts_subtitle: 'ការបញ្ចុះតម្លៃពិតពីម្ចាស់ទីលាន ដែលអាប់ដេតតាមទីលានបច្ចុប្បន្នលើវេទិកា។',
    landing_discount_headline: '{{discount}} នៅ {{field}}',
    landing_discount_description: 'សន្សំបាន ${{amount}}/ម៉ោង សម្រាប់ទីលាននេះនៅ {{city}}។',
    landing_discount_summary_suffix: 'កក់ឥឡូវនេះ មុនពេលម៉ោងបញ្ចុះតម្លៃត្រូវបានកក់អស់។',
    landing_discounts_empty_description: 'ម្ចាស់ទីលានអាចបន្ថែមការបញ្ចុះតម្លៃ ហើយវានឹងបង្ហាញនៅទីនេះដោយស្វ័យប្រវត្តិ។',
    landing_no_live_offers: 'មិនទាន់មានប្រម៉ូសិនផ្ទាល់',
    landing_check_back_later: 'សូមត្រឡប់មកមើលពេលក្រោយ',
    landing_featured_city: 'ទីក្រុងណែនាំ',
    landing_discount_field_label: 'ទីលាន៖',
    landing_discount_location_label: 'ទីតាំង៖',
    landing_book_discounted_field: 'កក់ទីលានបញ្ចុះតម្លៃ',
    landing_no_active_discounts: 'មិនទាន់មានការបញ្ចុះតម្លៃទីលានសកម្មនៅឡើយទេ។ នៅពេលម្ចាស់ទីលានបន្ថែមការបញ្ចុះតម្លៃ ផ្នែកនេះនឹងអាប់ដេតដោយស្វ័យប្រវត្តិ។',
    landing_discounts_coming_soon: 'ការបញ្ចុះតម្លៃនឹងមកដល់ឆាប់ៗ',
    landing_book_this_discount: 'កក់ប្រម៉ូសិននេះ',
    landing_no_offer_yet: 'មិនទាន់មានប្រម៉ូសិន',
    landing_original_price: 'តម្លៃដើម',
    landing_discounted_price: 'តម្លៃបន្ទាប់ពីបញ្ចុះ',
    landing_book_discounted_field: 'កក់ទីលានបញ្ចុះតម្លៃ',
    landing_facility_free_wifi_title: 'វ៉ាយហ្វាយឥតគិតថ្លៃ',
    landing_facility_free_wifi_description: 'មានអ៊ីនធឺណិតល្បឿនលឿន',
    landing_facility_free_parking_title: 'ចំណតឥតគិតថ្លៃ',
    landing_facility_free_parking_description: 'មានកន្លែងចតគ្រប់គ្រាន់',
    landing_facility_shower_rooms_title: 'បន្ទប់ងូតទឹក',
    landing_facility_shower_rooms_description: 'បន្ទប់ផ្លាស់ខោអាវស្អាត',
    landing_facility_cctv_security_title: 'សន្តិសុខកាមេរ៉ា',
    landing_facility_cctv_security_description: 'តាមដាន 24/7',
    landing_facility_led_floodlights_title: 'ភ្លើង LED',
    landing_facility_led_floodlights_description: 'ប្រព័ន្ធភ្លើងស្តង់ដារវិជ្ជាជីវៈ',
    landing_facility_cafeteria_title: 'កាហ្វេតេរីយា',
    landing_facility_cafeteria_description: 'អាហារសម្រន់ និងភេសជ្ជៈ',
    landing_facility_first_aid_title: 'ជំនួយបឋម',
    landing_facility_first_aid_description: 'មានជំនួយវេជ្ជសាស្ត្រត្រៀមរួច',
    landing_facility_air_conditioned_title: 'បន្ទប់ម៉ាស៊ីនត្រជាក់',
    landing_facility_air_conditioned_description: 'បន្ទប់មានការគ្រប់គ្រងសីតុណ្ហភាព',
    landing_facility_water_stations_title: 'កន្លែងទឹក',
    landing_facility_water_stations_description: 'ទឹកផឹកឥតគិតថ្លៃ',
    landing_facility_spectator_area_title: 'កន្លែងទស្សនា',
    landing_facility_spectator_area_description: 'មានកន្លែងអង្គុយសម្រាប់អ្នកគាំទ្រ',
    landing_facility_equipment_rental_title: 'ជួលឧបករណ៍',
    landing_facility_equipment_rental_description: 'បាល់ អាវហ្វឹកហាត់ និងសម្ភារៈ',
    landing_facility_lounge_area_title: 'កន្លែងសម្រាក',
    landing_facility_lounge_area_description: 'កន្លែងរង់ចាំមានផាសុកភាព',
    landing_premium_daily_maintenance: 'ថែទាំរាល់ថ្ងៃ',
    landing_premium_professional_standards: 'ស្តង់ដារវិជ្ជាជីវៈ',
    landing_premium_safety_certified: 'បានបញ្ជាក់សុវត្ថិភាព',
    landing_premium_eco_friendly: '\u1787\u17bd\u1799\u1790\u17c2\u1794\u179a\u17b7\u179f\u17d2\u1790\u17b6\u1793',
    common_saving: '\u1780\u17c6\u1796\u17bb\u1784\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780...',
    common_new: '\u1790\u17d2\u1798\u17b8',
    common_current: '\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793',
    surface_artificial_turf: '\u179f\u17d2\u1798\u17c5\u179f\u17b7\u1794\u17d2\u1794\u1793\u17b7\u1798\u17d2\u1798\u17b7\u178f',
    surface_natural_grass: '\u179f\u17d2\u1798\u17c5\u1792\u1798\u17d2\u1798\u1787\u17b6\u178f\u17b7',
    surface_concrete: '\u1794\u17c1\u178f\u17bb\u1784',
    surface_indoor: '\u1780\u17d2\u1793\u17bb\u1784\u179f\u17b6\u179b',
    owner_field_edit_badge: '\u1780\u17c2\u1794\u17d2\u179a\u17c2\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_create_badge: '\u1794\u1784\u17d2\u1780\u17be\u178f\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_edit_title: '\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_create_title: '\u1794\u1793\u17d2\u1790\u17c2\u1798\u1791\u17b8\u179b\u17b6\u1793\u1790\u17d2\u1798\u17b8',
    owner_field_modal_subtitle: '\u1780\u17c2\u1794\u17d2\u179a\u17c2\u178f\u1798\u17d2\u179b\u17c3 \u1791\u17b8\u178f\u17b6\u17c6\u1784 \u179f\u17c1\u179c\u17b6\u1780\u1798\u17d2\u1798 \u1793\u17b7\u1784\u179a\u17bc\u1794\u1797\u17b6\u1796\u1793\u17c5\u1780\u1793\u17d2\u179b\u17c2\u1784\u178f\u17c2\u1798\u17bd\u1799\u17d4',
    owner_field_close_form: '\u1794\u17b7\u1791\u1791\u1798\u17d2\u179a\u1784\u17cb\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_live_preview: '\u1798\u17be\u179b\u1787\u17b6\u1798\u17bb\u1793\u1795\u17d2\u1791\u17b6\u179b\u17cb',
    owner_field_set_price: '\u1780\u17c6\u178e\u178f\u17cb\u178f\u1798\u17d2\u179b\u17c3',
    owner_field_type_label: '\u1794\u17d2\u179a\u1797\u17c1\u1791\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_set_capacity: '\u1780\u17c6\u178e\u178f\u17cb\u1785\u17c6\u1793\u17bd\u1793',
    owner_field_details_title: '\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_details_subtitle: '\u1780\u17c6\u178e\u178f\u17cb\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u179f\u17c6\u1781\u17b6\u1793\u17cb\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784\u1783\u17be\u1789\u1798\u17bb\u1793\u1796\u17c1\u179b\u1780\u1780\u17cb\u17d4',
    owner_field_name_label: '\u1788\u17d2\u1798\u17c4\u17c7\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_name_placeholder: '\u1788\u17d2\u1798\u17c4\u17c7\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_price_label: '\u178f\u1798\u17d2\u179b\u17c3\u1780\u17d2\u1793\u17bb\u1784\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784',
    owner_field_price_placeholder: '\u178f\u1798\u17d2\u179b\u17c3\u1780\u17d2\u1793\u17bb\u1784\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784',
    owner_field_capacity_label: '\u1785\u17c6\u1793\u17bd\u1793\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784',
    owner_field_capacity_placeholder: '\u1785\u17c6\u1793\u17bd\u1793\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784',
    owner_field_discount_label: '\u1797\u17b6\u1782\u179a\u1799\u1794\u1789\u17d2\u1785\u17bb\u17c7\u178f\u1798\u17d2\u179b\u17c3',
    owner_field_type_title: '\u1794\u17d2\u179a\u1797\u17c1\u1791\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_surface_title: '\u1794\u17d2\u179a\u1797\u17c1\u1791\u1795\u17d2\u1791\u17c3',
    owner_field_amenities_label: '\u179f\u17c1\u179c\u17b6\u1780\u1798\u17d2\u1798\u1794\u1793\u17d2\u1790\u17c2\u1798',
    owner_field_amenities_placeholder: '\u1785\u17c6\u178e\u178f, \u1784\u17bc\u178f\u1791\u17b9\u1780, \u1797\u17d2\u179b\u17be\u1784',
    owner_field_location_title: '\u1791\u17b8\u178f\u17b6\u17c6\u1784',
    owner_field_location_subtitle: '\u179f\u17d2\u179c\u17c2\u1784\u179a\u1780 \u1785\u17bb\u1785 \u17ac\u17a2\u17bc\u179f\u179f\u1789\u17d2\u1789\u17b6\u1791\u17b8\u178f\u17b6\u17c6\u1784\u178a\u17be\u1798\u17d2\u1794\u17b8\u1780\u17c6\u178e\u178f\u17cb\u1791\u17b8\u178f\u17b6\u17c6\u1784\u1791\u17b8\u179b\u17b6\u1793\u17d4',
    owner_field_photos_title: '\u179a\u17bc\u1794\u1797\u17b6\u1796',
    owner_field_photos_subtitle: '\u17a2\u17b6\u1794\u17cb\u17a1\u17bc\u178a\u179a\u17bc\u1794\u1797\u17b6\u1796\u1794\u17b6\u1793\u179a\u17a0\u17bc\u178f\u178a\u179b\u17cb 5 \u179f\u1793\u17d2\u179b\u17b9\u1780\u17d4 \u179a\u17bc\u1794\u1797\u17b6\u1796\u1793\u17b9\u1784\u178f\u17d2\u179a\u17bc\u179c\u1794\u1784\u17d2\u17a0\u17b6\u1794\u17cb\u1798\u17bb\u1793\u17a2\u17b6\u1794\u17cb\u17a1\u17bc\u178a\u178a\u17be\u1798\u17d2\u1794\u17b8\u17b2\u17d2\u1799\u1791\u17c6\u1796\u17d0\u179a\u179b\u17bf\u1793\u17d4',
    owner_field_change_photos: '\u1794\u17d2\u178a\u17bc\u179a\u179a\u17bc\u1794\u1797\u17b6\u1796',
    owner_field_upload_photos: '\u17a2\u17b6\u1794\u17cb\u17a1\u17bc\u178a\u179a\u17bc\u1794\u1797\u17b6\u1796',
    owner_field_new_photos_ready: '\u179a\u17bc\u1794\u1797\u17b6\u1796\u1790\u17d2\u1798\u17b8\u179a\u17bd\u1785\u179a\u17b6\u179b\u17cb \u17a0\u17be\u1799\u1793\u17b9\u1784\u1787\u17c6\u1793\u17bd\u179f\u179a\u17bc\u1794\u1797\u17b6\u1796\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1793\u17c5\u1796\u17c1\u179b\u17a2\u17d2\u1793\u1780\u1785\u17bb\u1785\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780',
    owner_field_showing_current_images: '\u1780\u17c6\u1796\u17bb\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u179a\u17bc\u1794\u1797\u17b6\u1796\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793',
    owner_field_no_photos_selected: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1794\u17b6\u1793\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u179a\u17bc\u1794\u1797\u17b6\u1796\u1791\u17c1\u17d4',
    owner_field_description_title: '\u1796\u17b7\u1796\u178e\u17cc\u1793\u17b6\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_description_subtitle: '\u1785\u17c2\u1780\u179a\u17c6\u179b\u17c2\u1780\u17a2\u17d2\u179c\u17b8\u178a\u17c2\u179b\u1792\u17d2\u179c\u17be\u17b2\u17d2\u1799\u1791\u17b8\u179b\u17b6\u1793\u1793\u17c1\u17c7\u1796\u17b7\u179f\u17c1\u179f\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784 \u1793\u17b7\u1784\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793\u17d4',
    owner_field_description_placeholder: '\u1796\u17b7\u1796\u178e\u17cc\u1793\u17b6\u1791\u17b8\u179b\u17b6\u1793',
    owner_field_ready_to_save: '\u179a\u17bd\u1785\u179a\u17b6\u179b\u17cb\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780',
    owner_field_fill_required: '\u1794\u17c6\u1796\u17c1\u1789\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1785\u17b6\u17c6\u1794\u17b6\u1785\u17cb\uff1a \u1788\u17d2\u1798\u17c4\u17c7 \u178f\u1798\u17d2\u179b\u17c3 \u1785\u17c6\u1793\u17bd\u1793 \u1793\u17b7\u1784\u1791\u17b8\u178f\u17b6\u17c6\u1784',
    owner_bookings_title: '\u179f\u17c6\u178e\u17be\u1780\u1780\u17cb',
    owner_bookings_subtitle: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798 \u17ac\u1794\u17c4\u17c7\u1794\u1784\u17cb\u179f\u17c6\u178e\u17be\u1780\u1780\u17cb\u17d4 \u1780\u17b6\u179a\u1794\u1789\u17d2\u1785\u1794\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178f\u17d2\u179a\u17bc\u179c\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1793\u17c5\u1780\u17d2\u1793\u17bb\u1784 Matches\u17d4',
    owner_bookings_load_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1791\u17b6\u1789\u1799\u1780\u179f\u17c6\u178e\u17be\u1780\u1780\u17cb\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    owner_bookings_select_date_first: '\u179f\u17bc\u1798\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791\u1798\u17bb\u1793\u1796\u17c1\u179b\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u1780\u17b6\u179a\u1780\u1780\u17cb\u1793\u17c1\u17c7\u17d4',
    owner_bookings_invalid_date: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791\u1780\u17b6\u179a\u1780\u1780\u17cb\u1794\u17b6\u1793\u1791\u17c1\u17d4 \u179f\u17bc\u1798\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791\u178f\u17d2\u179a\u17b9\u1798\u178f\u17d2\u179a\u17bc\u179c\u17d4',
    owner_bookings_confirm_accept_message: '\u178f\u17be\u17a2\u17d2\u1793\u1780\u1785\u1784\u17cb\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be\u1780\u1780\u17cb\u1793\u17c1\u17c7\u1798\u17c2\u1793\u1791\u17c1\u17d4',
    owner_bookings_confirm_cancel_message: '\u178f\u17be\u17a2\u17d2\u1793\u1780\u1785\u1784\u17cb\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb\u1793\u17c1\u17c7\u1798\u17c2\u1793\u1791\u17c1\u17d4',
    owner_bookings_cancel_title: '\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_update_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u1780\u17b6\u179a\u1780\u1780\u17cb\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    owner_bookings_cancellation_pending: '\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u1780\u17b6\u179a\u1794\u17c4\u17c7\u1794\u1784\u17cb',
    owner_bookings_booked: '\u1794\u17b6\u1793\u1780\u1780\u17cb',
    owner_bookings_booked_subtitle: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u178a\u17c2\u179b\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798 \u179a\u17bd\u1785\u179a\u17b6\u179b\u17cb\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17b6\u179a\u179b\u17c1\u1784\u17d4',
    owner_bookings_completed_subtitle: '\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178a\u17c2\u179b\u1794\u17c9\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb \u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u1780\u178f\u17cb\u178f\u17d2\u179a\u17b6\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    owner_bookings_requests: '\u179f\u17c6\u178e\u17be',
    owner_bookings_showing: '\u1780\u17c6\u1796\u17bb\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\uff1a {{status}}',
    owner_bookings_items: '{{count}} \u1792\u17b6\u178f\u17bb',
    owner_bookings_empty_title: '\u1782\u17d2\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_empty_description: '\u179f\u17bc\u1798\u179f\u17b6\u179b\u17d2\u1794\u1784\u178f\u1798\u17d2\u179a\u1784\u17cb\u1795\u17d2\u179f\u17c1\u1784 \u17ac\u179a\u1784\u17cb\u1785\u17b6\u17c6\u179f\u17c6\u178e\u17be\u1780\u1780\u17cb\u1790\u17d2\u1798\u17b8\u17d4',
    owner_bookings_home_team: '\u1780\u17d2\u179a\u17bb\u1798\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1795\u17d2\u1791\u17c7',
    owner_bookings_away_team: '\u1780\u17d2\u179a\u17bb\u1798\u1797\u17d2\u1789\u17c0\u179c',
    owner_bookings_result_recorded: '\u179b\u1791\u17d2\u1792\u1795\u179b\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u1780\u178f\u17cb\u178f\u17d2\u179a\u17b6\u17d4 {{home}} {{homeScore}} - {{awayScore}} {{away}}',
    owner_bookings_match_date: '\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791\u1794\u17d2\u179a\u1780\u17bd\u178f',
    owner_bookings_accept: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_use_matches: '\u1794\u17d2\u179a\u17be\u1791\u17c6\u1796\u17d0\u179a Matches \u178a\u17be\u1798\u17d2\u1794\u17b8\u1794\u1789\u17d2\u1785\u1794\u17cb',
    owner_bookings_no_actions: '\u1782\u17d2\u1798\u17b6\u1793\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796',
    owner_bookings_tip: '\u1782\u1793\u17d2\u179b\u17b9\u17c7\uff1a \u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u17b2\u17d2\u1799\u1794\u17b6\u1793\u179b\u17bf\u1793 \u178a\u17be\u1798\u17d2\u1794\u17b8\u1794\u1784\u17d2\u1780\u17be\u1793\u17a2\u178f\u17d2\u179a\u17b6\u1780\u17b6\u179a\u1780\u1780\u17cb\u1791\u17b8\u179b\u17b6\u1793\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780\u17d4',
    owner_bookings_details_title: '\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u179b\u1798\u17d2\u17a2\u17b7\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_details_message: '\u1798\u17be\u179b\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb\u1796\u17c1\u1789\u179b\u17c1\u1789 \u1793\u17b7\u1784\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u179f\u17c6\u178e\u17be\u1793\u17c1\u17c7\u17d4',
    owner_bookings_close: '\u1794\u17b7\u1791',
    owner_bookings_details_badge: '\u179b\u1798\u17d2\u17a2\u17b7\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_info: '\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_date: '\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791',
    owner_bookings_start_time: '\u1798\u17c9\u17c4\u1784\u1785\u17b6\u1794\u17cb\u1795\u17d2\u178f\u17be\u1798',
    owner_bookings_end_time: '\u1798\u17c9\u17c4\u1784\u1794\u1789\u17d2\u1785\u1794\u17cb',
    owner_bookings_id: '\u179b\u17c1\u1781\u1780\u17bc\u178a\u1780\u17b6\u179a\u1780\u1780\u17cb',
    owner_bookings_captain_account: '\u1782\u178e\u1793\u17b8\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793',
    owner_bookings_captain_account_subtitle: '\u1793\u179a\u178e\u17b6\u1794\u1784\u17d2\u1780\u17be\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb\u1793\u17c1\u17c7',
    owner_bookings_no_team_assigned: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1785\u17b6\u178f\u17cb\u1782\u17d2\u179a\u17bb\u1798',
    owner_bookings_team_not_assigned: '\u1780\u17d2\u179a\u17bb\u1798\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1785\u17b6\u178f\u17cb',
    owner_bookings_opponent_team: '\u1780\u17d2\u179a\u17bb\u1798\u1782\u17bc\u1794\u17d2\u179a\u1787\u17c2\u1784',
    owner_bookings_not_assigned_yet: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1785\u17b6\u178f\u17cb\u1793\u17c5\u17a1\u17be\u1799',
    owner_bookings_other_info: '\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1795\u17d2\u179f\u17c1\u1784\u1791\u17c0\u178f',
    owner_bookings_location_unavailable: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1791\u17b8\u178f\u17b6\u17c6\u1784',
    owner_matches_subtitle: '\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u179a\u179c\u17b6\u1784\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u17d4 \u1794\u17be\u1780\u1780\u17b6\u178f\u178e\u17b6\u1798\u17bd\u1799\u178a\u17be\u1798\u17d2\u1794\u17b8\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u179b\u1791\u17d2\u1792\u1795\u179b\u17d4',
    owner_matches_load_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1791\u17b6\u1789\u1799\u1780\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    owner_matches_cards: '\u1780\u17b6\u178f\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f',
    owner_matches_count: '{{count}} \u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f',
    owner_matches_empty_title: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f',
    owner_matches_empty_description: '\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1793\u17b9\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7 \u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1796\u17b8\u1780\u17b6\u179a\u1780\u1780\u17cb\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u178a\u17c4\u1799\u1780\u17d2\u179a\u17bb\u1798\u1791\u17b6\u17c6\u1784\u1796\u17b8\u179a\u17d4',
    owner_matches_home_team: '\u1780\u17d2\u179a\u17bb\u1798\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1795\u17d2\u1791\u17c7',
    owner_matches_away_team: '\u1780\u17d2\u179a\u17bb\u1798\u1797\u17d2\u1789\u17c0\u179c',
    owner_matches_final: '\u179b\u1791\u17d2\u1792\u1795\u179b\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799',
    owner_matches_mvp_label: 'MVP: {{name}}',
    owner_matches_input_locked: '\u1780\u17b6\u179a\u1794\u1789\u17d2\u1785\u17bc\u179b\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u1785\u17b6\u1780\u17cb\u179f\u17c4 \u179a\u17a0\u17bc\u178f\u178a\u179b\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1793\u17c1\u17c7\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u179f\u1798\u17d2\u1782\u17b6\u179b\u17cb\u1790\u17b6\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb\u17d4',
    owner_matches_score_locked_mvp_available: '\u1780\u17b6\u179a\u1780\u17c2\u1794\u17d2\u179a\u17c2\u1796\u17b7\u1793\u17d2\u1791\u17bb\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u1785\u17b6\u1780\u17cb\u179f\u17c4\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1796\u17b8 24 \u1798\u17c9\u17c4\u1784 \u1794\u17c9\u17bb\u1793\u17d2\u178f\u17c2 MVP \u1793\u17c5\u178f\u17c2\u17a2\u17b6\u1785\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1794\u17b6\u1793\u1781\u17b6\u1784\u1780\u17d2\u179a\u17c4\u1798\u17d4',
    owner_matches_save_result_then_mvp: '\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780\u179b\u1791\u17d2\u1792\u1795\u179b\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1787\u17b6\u1798\u17bb\u1793 \u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1798\u1780\u1780\u17c6\u178e\u178f\u17cb MVP\u17d4',
    owner_matches_confirm_completed: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u1790\u17b6\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb',
    owner_matches_request_admin_change: '\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u17b2\u17d2\u1799 Admin \u1780\u17c2\u1794\u17d2\u179a\u17c2',
    owner_matches_result_form: '\u1791\u1798\u17d2\u179a\u1784\u17cb\u179b\u1791\u17d2\u1792\u1795\u179b',
    owner_matches_team_score: '\u1796\u17b7\u1793\u17d2\u1791\u17bb {{team}}',
    owner_matches_notes_optional: '\u1780\u17c6\u178e\u178f\u17cb\u1785\u17c6\u178e\u17b6\u17c6\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f (\u1798\u17b7\u1793\u1785\u17b6\u17c6\u1794\u17b6\u1785\u17cb)',
    owner_matches_mvp_player: '\u1780\u17b8\u17a1\u17b6\u1780\u179a MVP',
    owner_matches_select_one_player: '\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1780\u17b8\u17a1\u17b6\u1780\u179a\u1798\u17d2\u1793\u17b6\u1780\u17cb',
    owner_matches_save_result_first_short: '\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780\u179b\u1791\u17d2\u1792\u1795\u179b\u1787\u17b6\u1798\u17bb\u1793',
    owner_matches_player_team: '{{label}} ({{team}})',
    owner_matches_loading_players: '\u1780\u17c6\u1796\u17bb\u1784\u1795\u17d2\u1791\u17bb\u1780\u1780\u17b8\u17a1\u17b6\u1780\u179a\u178a\u17c2\u179b\u17a2\u17b6\u1785\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1794\u17b6\u1793...',
    owner_matches_no_players: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u1780\u17b8\u17a1\u17b6\u1780\u179a\u178a\u17c2\u179b\u17a2\u17b6\u1785\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb MVP \u1791\u17c1\u17d4',
    owner_matches_update_result: '\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u179b\u1791\u17d2\u1792\u1795\u179b',
    owner_matches_save_result: '\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780\u179b\u1791\u17d2\u1792\u1795\u179b',
    owner_matches_update_mvp: '\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796 MVP',
    owner_matches_set_mvp: '\u1780\u17c6\u178e\u178f\u17cb MVP',
    owner_matches_mark_completed_first: '\u179f\u17bc\u1798\u179f\u1798\u17d2\u1782\u17b6\u179b\u17cb\u1790\u17b6\u1780\u17b6\u179a\u1780\u1780\u17cb\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb\u1787\u17b6\u1798\u17bb\u1793\u179f\u17b7\u1793\u17d4',
    owner_matches_showing: '\u1780\u17c6\u1796\u17bb\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789 {{visible}} \u1793\u17c3 {{total}} \u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f',
    owner_matches_tip: '\u1785\u17bb\u1785\u1780\u17b6\u178f\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178e\u17b6\u1798\u17bd\u1799 \u178a\u17be\u1798\u17d2\u1794\u17b8\u1794\u17be\u1780\u1791\u1798\u17d2\u179a\u1784\u17cb\u179b\u1791\u17d2\u1792\u1795\u179b\u17d4',
    owner_matches_no_admin: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u1782\u178e\u1793\u17b8 Admin \u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1791\u1791\u17bd\u179b\u179f\u17c6\u178e\u17be\u1793\u17c1\u17c7\u1791\u17c1\u17d4',
    owner_matches_unknown_date: '\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791\u1798\u17b7\u1793\u179f\u17d2\u1782\u17b6\u179b\u17cb',
    owner_matches_change_request_title: '\u179f\u17c6\u178e\u17be\u179f\u17bb\u17c6\u1780\u17c2\u1794\u17d2\u179a\u17c2\u179b\u1791\u17d2\u1792\u1795\u179b\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f',
    owner_matches_change_request_message: '\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793\u1794\u17b6\u1793\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u17b2\u17d2\u1799 Admin \u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1780\u17b6\u179a\u1780\u17c2\u1794\u17d2\u179a\u17c2\u179b\u1791\u17d2\u1792\u1795\u179b\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb {{home}} vs {{away}} ({{when}})\u17d4',
    owner_matches_change_request_sent: '\u1794\u17b6\u1793\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u1791\u17c5 Admin \u179a\u17bd\u1785\u17a0\u17be\u1799\u17d4 \u1796\u17bd\u1780\u1782\u17c1\u1793\u17b9\u1784\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1780\u17b6\u179a\u1780\u17c2\u1794\u17d2\u179a\u17c2\u179b\u1791\u17d2\u1792\u1795\u179b\u1793\u17c1\u17c7\u17d4',
    owner_matches_change_request_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u17b2\u17d2\u1799 Admin \u1794\u17b6\u1793\u1791\u17c1\u17d4',
    owner_matches_result_after_completed: '\u17a2\u17b6\u1785\u1794\u1789\u17d2\u1785\u17bc\u179b\u179b\u1791\u17d2\u1792\u1795\u179b\u1794\u17b6\u1793 \u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1796\u17b8\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb\u1794\u17c9\u17bb\u178e\u17d2\u178e\u17c4\u17c7\u17d4',
    owner_matches_edit_locked: '\u1780\u17b6\u179a\u1780\u17c2\u1794\u17d2\u179a\u17c2\u179b\u1791\u17d2\u1792\u1795\u179b\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u1785\u17b6\u1780\u17cb\u179f\u17c4\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1796\u17b8 24 \u1798\u17c9\u17c4\u1784\u17d4 \u179f\u17bc\u1798\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u17b2\u17d2\u1799 Admin \u1780\u17c2\u1794\u17d2\u179a\u17c2\u17d4',
    owner_matches_enter_scores: '\u179f\u17bc\u1798\u1794\u1789\u17d2\u1785\u17bc\u179b\u1796\u17b7\u1793\u17d2\u1791\u17bb\u1780\u17d2\u179a\u17bb\u1798\u1791\u17b6\u17c6\u1784\u1796\u17b8\u179a\u17d4',
    owner_matches_scores_valid: '\u1796\u17b7\u1793\u17d2\u1791\u17bb\u178f\u17d2\u179a\u17bc\u179c\u1787\u17b6\u179b\u17c1\u1781\u1782\u178f\u17cb\u1798\u17b7\u1793\u17a2\u17c7\u1798\u17b6\u1793\u17d4',
    owner_matches_save_result_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780\u179b\u1791\u17d2\u1792\u1795\u179b\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    owner_matches_mvp_after_completed: 'MVP \u17a2\u17b6\u1785\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1794\u17b6\u1793 \u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1796\u17b8\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb\u1794\u17c9\u17bb\u178e\u17d2\u178e\u17c4\u17c7\u17d4',
    owner_matches_save_result_first: '\u179f\u17bc\u1798\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780\u179b\u1791\u17d2\u1792\u1795\u179b\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1787\u17b6\u1798\u17bb\u1793 \u1798\u17bb\u1793\u1796\u17c1\u179b\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f MVP\u17d4',
    owner_matches_choose_mvp: '\u179f\u17bc\u1798\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1780\u17b8\u17a1\u17b6\u1780\u179a\u1798\u17d2\u1793\u17b6\u1780\u17cb \u178a\u17be\u1798\u17d2\u1794\u17b8\u1780\u17c6\u178e\u178f\u17cb\u1787\u17b6 MVP\u17d4',
    owner_matches_mvp_saved: '\u1794\u17b6\u1793\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780 MVP \u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    owner_matches_save_mvp_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u179a\u1780\u17d2\u179f\u17b6\u1791\u17bb\u1780 MVP \u1794\u17b6\u1793\u1791\u17c1\u17d4',
    owner_matches_mark_completed_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u179f\u1798\u17d2\u1782\u17b6\u179b\u17cb\u1790\u17b6\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    dashboard_load_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1791\u17b6\u1789\u1799\u1780\u1795\u17d2\u1791\u17b6\u17c6\u1784\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    dashboard_captain_overview_badge: '\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u1791\u17bc\u1791\u17c5\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793',
    dashboard_captain_description: '\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1780\u17d2\u179a\u17bb\u1798\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780 \u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798 \u1793\u17b7\u1784\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1780\u17b6\u179a\u1780\u1780\u17cb\u17b2\u17d2\u1799\u1794\u17b6\u1793\u179b\u17d2\u17a2\u17d4',
    dashboard_captained_teams: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u178a\u17b9\u1780\u1793\u17b6\u17c6',
    dashboard_my_bookings: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u179a\u1794\u179f\u17cb\u1781\u17d2\u1789\u17bb\u17c6',
    dashboard_fields_available: '\u1791\u17b8\u179b\u17b6\u1793\u178a\u17c2\u179b\u17a2\u17b6\u1785\u1780\u1780\u17cb\u1794\u17b6\u1793',
    dashboard_next_booking: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb',
    dashboard_nothing_scheduled: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u17c6\u178e\u178f\u17cb\u1780\u17b6\u179b\u179c\u17b7\u1797\u17b6\u1782',
    dashboard_create_booking_start: '\u1794\u1784\u17d2\u1780\u17be\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb\u178a\u17be\u1798\u17d2\u1794\u17b8\u1785\u17b6\u1794\u17cb\u1795\u17d2\u178f\u17be\u1798',
    dashboard_teams_managed: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784',
    dashboard_active_captain_workspaces: '\u1780\u1793\u17d2\u179b\u17c2\u1784\u1780\u17b6\u179a\u1784\u17b6\u179a\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u17a2\u17b6\u1785\u1794\u17d2\u179a\u17be\u1794\u17b6\u1793',
    dashboard_create_or_captain_team: '\u1794\u1784\u17d2\u1780\u17be\u178f\u1780\u17d2\u179a\u17bb\u1798 \u17ac\u1780\u17d2\u179b\u17b6\u1799\u1787\u17b6\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793',
    dashboard_join_queue: '\u1787\u17bd\u179a\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798',
    dashboard_requests_waiting_review: '\u179f\u17c6\u178e\u17be\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u17a2\u17d2\u1793\u1780\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799',
    dashboard_create_booking: '\u1794\u1784\u17d2\u1780\u17be\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb',
    dashboard_reserve_field_team: '\u1780\u1780\u17cb\u1791\u17b8\u179b\u17b6\u1793\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17d2\u179a\u17bb\u1798\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780',
    dashboard_manage_teams: '\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_review_members_requests: '\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u1798\u17b6\u1787\u17b7\u1780 \u1793\u17b7\u1784\u179f\u17c6\u178e\u17be',
    dashboard_find_fields: '\u179f\u17d2\u179c\u17c2\u1784\u179a\u1780\u1791\u17b8\u179b\u17b6\u1793',
    dashboard_browse_venues: '\u179a\u1780\u1798\u17be\u179b\u1791\u17b8\u178f\u17b6\u17c6\u1784\u178a\u17c2\u179b\u17a2\u17b6\u1785\u1794\u17d2\u179a\u17be\u1794\u17b6\u1793',
    dashboard_pending_join_requests: '\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6',
    dashboard_pending_join_requests_desc: '\u1792\u17d2\u179c\u17be\u17b2\u17d2\u1799\u1780\u17b6\u179a\u1785\u17bc\u179b\u179a\u17bd\u1798\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c6\u178e\u17be\u179a\u1780\u17b6\u179a\u179b\u17d2\u17a2 \u178a\u17c4\u1799\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1787\u17bd\u179a\u179f\u17c6\u178e\u17be\u17b2\u17d2\u1799\u1794\u17b6\u1793\u179b\u17bf\u1793\u17d4',
    dashboard_no_pending_requests: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u179f\u17c6\u178e\u17be\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6',
    dashboard_join_requests_appear_here: '\u1793\u17c5\u1796\u17c1\u179b\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u1785\u17bc\u179b\u179a\u17bd\u1798 \u1796\u17bd\u1780\u1782\u17c1\u1793\u17b9\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7\u17d4',
    dashboard_recent_bookings: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1790\u17d2\u1798\u17b8\u17d7',
    dashboard_recent_bookings_desc: '\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17b6\u179a\u1780\u1780\u17cb\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799 \u178a\u17c2\u179b\u1797\u17d2\u1787\u17b6\u1794\u17cb\u1787\u17b6\u1798\u17bd\u1799\u1782\u178e\u1793\u17b8\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780\u17d4',
    dashboard_view_all: '\u1798\u17be\u179b\u1791\u17b6\u17c6\u1784\u17a2\u179f\u17cb',
    dashboard_field_booking: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1791\u17b8\u179b\u17b6\u1793',
    dashboard_no_recent_bookings: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb\u1790\u17d2\u1798\u17b8\u17d7',
    dashboard_recent_bookings_appear: '\u1793\u17c5\u1796\u17c1\u179b\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb \u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799\u1793\u17b9\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7\u17d4',
    dashboard_team_snapshot: '\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_team_snapshot_desc: '\u1798\u17be\u179b\u1791\u17bc\u1791\u17c5\u17a2\u17c6\u1796\u17b8\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u178a\u17b9\u1780\u1793\u17b6\u17c6 \u1793\u17b7\u1784\u1780\u17b6\u179a\u1784\u17b6\u179a\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u179a\u1794\u179f\u17cb\u1796\u17bd\u1780\u1782\u17c1\u17d4',
    dashboard_open_teams: '\u1794\u17be\u1780\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_captained_teams_small: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u178a\u17b9\u1780\u1793\u17b6\u17c6',
    dashboard_teams_actively_manage: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u1780\u17c6\u1796\u17bb\u1784\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1799\u17c9\u17b6\u1784\u179f\u1780\u1798\u17d2\u1798',
    dashboard_pending_join_requests_small: '\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6',
    dashboard_players_waiting_decision: '\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u1780\u17b6\u179a\u179f\u1798\u17d2\u179a\u17c1\u1785\u1785\u17b7\u178f\u17d2\u178f',
    dashboard_captain_tip: '\u1782\u1793\u17d2\u179b\u17b9\u17c7\uff1a \u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u17b2\u17d2\u1799\u1794\u17b6\u1793\u179b\u17bf\u1793 \u178a\u17be\u1798\u17d2\u1794\u17b8\u1780\u17d2\u179a\u17bb\u1798\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780\u178f\u17d2\u179a\u17c0\u1798\u179a\u17bd\u1785\u179a\u17b6\u179b\u17cb\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb \u1793\u17b7\u1784\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17be\u1780\u1785\u17c6\u17a0\u17d4',
    open_matches_access_only: '\u1798\u17bb\u1781\u1784\u17b6\u179a\u1793\u17c1\u17c7\u17a2\u17b6\u1785\u1794\u17d2\u179a\u17be\u1794\u17b6\u1793\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u178f\u17c2\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793\u1780\u17d2\u179a\u17bb\u1798 \u1793\u17b7\u1784\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793\u1794\u17c9\u17bb\u178e\u17d2\u178e\u17c4\u17c7\u17d4',
    open_matches_load_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1791\u17b6\u1789\u1799\u1780\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17be\u1780\u1785\u17c6\u17a0\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    open_matches_available_count: '{{count}} \u17a2\u17b6\u1785\u1785\u17bc\u179b\u179a\u17bd\u1798\u1794\u17b6\u1793',
    open_matches_need_team: '\u17a2\u17d2\u1793\u1780\u178f\u17d2\u179a\u17bc\u179c\u1780\u17b6\u179a\u1780\u17d2\u179a\u17bb\u1798\u1799\u17c9\u17b6\u1784\u178f\u17b7\u1785\u1798\u17bd\u1799 \u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u1787\u17b6\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793 \u178a\u17be\u1798\u17d2\u1794\u17b8\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17be\u1780\u1785\u17c6\u17a0\u17d4',
    open_matches_choose_team: '\u179f\u17bc\u1798\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1780\u17d2\u179a\u17bb\u1798\u1798\u17bb\u1793\u1796\u17c1\u179b\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u17d4',
    open_matches_request_success: '\u1794\u17b6\u1793\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    open_matches_request_failed: '\u1798\u17b7\u1793\u17a2\u17b6\u1785\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    open_matches_owner_team: '\u1780\u17d2\u179a\u17bb\u1798\u1798\u17d2\u1785\u17b6\u179f\u17cb\uff1a {{name}}',
    open_matches_active_members: '{{count}} \u179f\u1798\u17b6\u1787\u17b7\u1780\u1780\u17c6\u1796\u17bb\u1784\u179f\u1780\u1798\u17d2\u1798',
    open_matches_rate: '\u178f\u1798\u17d2\u179b\u17c3\uff1a ${{rate}}/\u1798\u17c9\u17c4\u1784',
    open_matches_discount: '(\u1794\u1789\u17d2\u1785\u17bb\u17c7 {{percent}}%)',
    open_matches_pending_exists: '\u17a2\u17d2\u1793\u1780\u1798\u17b6\u1793\u179f\u17c6\u178e\u17be\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1793\u17c1\u17c7\u179a\u17bd\u1785\u17a0\u17be\u1799\u17d4',
    open_matches_select_team: '\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1780\u17d2\u179a\u17bb\u1798\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780',
    open_matches_optional_message: '\u179f\u17b6\u179a\u179f\u17d2\u1798\u17d0\u1782\u17b6\u179b\u17cb (\u1798\u17b7\u1793\u1785\u17b6\u17c6\u1794\u17b6\u1785\u17cb)',
    open_matches_your_jersey: '\u17a2\u17b6\u179c\u1780\u17d2\u179a\u17bb\u1798\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780',
    open_matches_sending: '\u1780\u17c6\u1796\u17bb\u1784\u1795\u17d2\u1789\u17be...',
    open_matches_request_join: '\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u1785\u17bc\u179b\u179a\u17bd\u1798',
    open_matches_empty_title: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u17be\u1780\u1785\u17c6\u17a0\u1791\u17c1',
    open_matches_empty_description: '\u179f\u17bc\u1798\u1798\u1780\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1798\u17d2\u178f\u1784\u1791\u17c0\u178f\u1793\u17c5\u1796\u17c1\u179b\u1780\u17d2\u179a\u17c4\u1799 \u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1790\u17d2\u1798\u17b8\u17d7\u178a\u17c2\u179b\u1794\u17be\u1780\u178a\u17c4\u1799\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793\u1795\u17d2\u179f\u17c1\u1784\u17d4',
    notifications_mark_all_read: '\u179f\u1798\u17d2\u1782\u17b6\u179b\u17cb\u1791\u17b6\u17c6\u1784\u17a2\u179f\u17cb\u1790\u17b6\u1794\u17b6\u1793\u17a2\u17b6\u1793',
    notifications_empty_title: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1787\u17bc\u1793\u178a\u17c6\u178e\u17b9\u1784\u1791\u17c1\u17d4',
    notifications_approve_leave: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u17a2\u17c4\u1799\u1785\u17c1\u1789',
    notifications_view_team: '\u1798\u17be\u179b\u1780\u17d2\u179a\u17bb\u1798',
    notifications_mark_read: '\u179f\u1798\u17d2\u1782\u17b6\u179b\u17cb\u1790\u17b6\u1794\u17b6\u1793\u17a2\u17b6\u1793',
    dashboard_player_overview_badge: '\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u1791\u17bc\u1791\u17c5\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784',
    dashboard_player_description: '\u178f\u17b6\u1798\u178a\u17b6\u1793\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789 \u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17d2\u179a\u17bb\u1798 \u1793\u17b7\u1784\u1780\u17b6\u179a\u1780\u1780\u17cb\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780\u1793\u17c5\u1780\u1793\u17d2\u179b\u17c2\u1784\u178f\u17c2\u1798\u17bd\u1799\u17d4',
    dashboard_player_my_teams: '\u1780\u17d2\u179a\u17bb\u1798\u179a\u1794\u179f\u17cb\u1781\u17d2\u1789\u17bb\u17c6',
    dashboard_player_invitations: '\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789',
    dashboard_player_team_bookings: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_player_upcoming: '\u1781\u17b6\u1784\u1798\u17bb\u1781',
    dashboard_player_next_match_day: '\u1790\u17d2\u1784\u17c3\u1794\u17d2\u179a\u1780\u17bd\u178f\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb',
    dashboard_player_no_upcoming_booking: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb\u1781\u17b6\u1784\u1798\u17bb\u1781',
    dashboard_player_watch_activity: '\u179f\u17bc\u1798\u178f\u17b6\u1798\u178a\u17b6\u1793\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17d2\u179a\u17bb\u1798 \u1793\u17b7\u1784\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789',
    dashboard_player_my_teams_small: '\u1780\u17d2\u179a\u17bb\u1798\u1781\u17d2\u1789\u17bb\u17c6',
    dashboard_player_current_teams: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u1780\u17c6\u1796\u17bb\u1784\u179f\u17d2\u1790\u17b7\u178f\u1793\u17c5',
    dashboard_player_join_team_unlock: '\u1785\u17bc\u179b\u179a\u17bd\u1798\u1780\u17d2\u179a\u17bb\u1798 \u178a\u17be\u1798\u17d2\u1794\u17b8\u1794\u17be\u1780\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1794\u17d2\u179a\u1780\u17bd\u178f',
    dashboard_player_open_invites: '\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789\u178a\u17c2\u179b\u1794\u17be\u1780',
    dashboard_player_unread_invites: '\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u17a2\u17b6\u1793',
    dashboard_player_view_bookings: '\u1798\u17be\u179b\u1780\u17b6\u179a\u1780\u1780\u17cb',
    dashboard_player_see_upcoming_sessions: '\u1798\u17be\u179b\u179c\u1782\u17d2\u1782\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780',
    dashboard_player_explore_teams: '\u179f\u17d2\u179c\u17c2\u1784\u1799\u179b\u17cb\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_player_join_squad: '\u1785\u17bc\u179b\u179a\u17bd\u1798\u1780\u17d2\u179a\u17bb\u1798 \u17ac\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u179f\u1798\u17b6\u1787\u17b7\u1780',
    dashboard_player_browse_fields: '\u179a\u1780\u1798\u17be\u179b\u1791\u17b8\u179b\u17b6\u1793',
    dashboard_player_discover_venues: '\u179f\u17d2\u179c\u17c2\u1784\u179a\u1780\u1791\u17b8\u178f\u17b6\u17c6\u1784\u1793\u17c5\u1787\u17b7\u178f\u17a2\u17d2\u1793\u1780',
    dashboard_player_upcoming_bookings: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1781\u17b6\u1784\u1798\u17bb\u1781',
    dashboard_player_upcoming_bookings_desc: '\u179c\u1782\u17d2\u1782\u178a\u17c2\u179b\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798 \u17ac\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780 \u178f\u17b6\u1798\u179b\u17c6\u178a\u17b6\u1794\u17cb\u1796\u17c1\u179b\u179c\u17c1\u179b\u17b6\u17d4',
    dashboard_player_browse_create_booking: '\u179a\u1780\u1798\u17be\u179b\u1791\u17b8\u179b\u17b6\u1793 \u1793\u17b7\u1784\u1794\u1784\u17d2\u1780\u17be\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780\u17d4',
    dashboard_player_book_field: '\u1780\u1780\u17cb\u1791\u17b8\u179b\u17b6\u1793',
    dashboard_player_team_activity: '\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_player_team_activity_desc: '\u1798\u17be\u179b\u1791\u17bc\u1791\u17c5\u17a2\u17c6\u1796\u17b8\u179c\u178f\u17d2\u178f\u1798\u17b6\u1793\u1780\u17d2\u179a\u17bb\u1798\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793 \u1793\u17b7\u1784\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789\u17d4',
    dashboard_player_joined_teams: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u1794\u17b6\u1793\u1785\u17bc\u179b\u179a\u17bd\u1798',
    dashboard_player_member_teams: '\u1780\u17d2\u179a\u17bb\u1798\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u1780\u17c6\u1796\u17bb\u1784\u1787\u17b6\u179f\u1798\u17b6\u1787\u17b7\u1780',
    dashboard_player_pending_invitations: '\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6',
    dashboard_player_invites_waiting: '\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789\u178a\u17c2\u179b\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u1785\u1798\u17d2\u179b\u17be\u1799\u179a\u1794\u179f\u17cb\u17a2\u17d2\u1793\u1780',
    dashboard_player_tip: '\u1782\u1793\u17d2\u179b\u17b9\u17c7\uff1a \u1780\u17b6\u179a\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789 \u1793\u17b7\u1784\u1780\u17b6\u179a\u178f\u17b6\u1798\u178a\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7 \u1787\u17bd\u1799\u17a2\u17d2\u1799\u17a2\u17d2\u1793\u1780\u1785\u17bc\u179b\u1791\u17c5\u1780\u17b6\u1793\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u1781\u17b6\u1784\u1798\u17bb\u1781\u1794\u17b6\u1793\u179b\u17bf\u1793\u1787\u17b6\u1784\u1798\u17bb\u1793\u17d4',
    dashboard_owner_app_view_badge: '\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u1780\u1798\u17d2\u1798\u179c\u17b7\u1792\u17b8\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793',
    dashboard_owner_app_description: '\u1794\u17d2\u179a\u17be workspace \u1780\u1798\u17d2\u1798\u179c\u17b7\u1792\u17b8 \u178a\u17be\u1798\u17d2\u1794\u17b8\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u1780\u17d2\u179a\u17bb\u1798 \u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1780\u17b6\u179a\u17a2\u1789\u17d2\u1787\u17be\u1789 \u1793\u17b7\u1784\u1794\u1784\u17d2\u1780\u17be\u178f\u1780\u17b6\u179a\u1780\u1780\u17cb\u1780\u17d2\u1793\u17bb\u1784\u1793\u17b6\u1798\u1787\u17b6\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793\u17d4',
    dashboard_owner_reserve_field: '\u1780\u1780\u17cb\u1791\u17b8\u179b\u17b6\u1793\u1781\u178e\u17c8\u1796\u17c1\u179b\u1794\u17d2\u179a\u17be workspace \u1780\u1798\u17d2\u1798\u179c\u17b7\u1792\u17b8',
    dashboard_owner_join_manage_team: '\u1785\u17bc\u179b\u179a\u17bd\u1798 \u17ac\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_player_team_invitation_notifications: '\u1780\u17b6\u179a\u1787\u17bc\u1793\u178a\u17c6\u178e\u17b9\u1784\u17a2\u1789\u17d2\u1787\u17be\u1789\u1780\u17d2\u179a\u17bb\u1798',
    dashboard_player_no_invitation_notifications: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1787\u17bc\u1793\u178a\u17c6\u178e\u17b9\u1784\u17a2\u1789\u17d2\u1787\u17be\u1789\u1791\u17c1',
    dashboard_player_invitation_notifications_desc: '\u1793\u17c5\u1796\u17c1\u179b\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793\u17a2\u1789\u17d2\u1787\u17be\u1789\u17a2\u17d2\u1793\u1780\u1791\u17c5\u1780\u17d2\u179a\u17bb\u1798 \u179c\u17b6\u1793\u17b9\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7\u17d4',
    booking_load_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1795\u17d2\u1791\u17bb\u1780\u1780\u17b6\u179a\u1780\u1780\u17cb',
    booking_update_success: '\u1794\u17b6\u1793\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u1780\u17b6\u179a\u1780\u1780\u17cb\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    booking_update_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u179f\u17d2\u1790\u17b6\u1793\u1797\u17b6\u1796\u1780\u17b6\u179a\u1780\u1780\u17cb',
    booking_cancellation_sent: '\u1794\u17b6\u1793\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    booking_cancellation_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb',
    booking_opponent_setting_updated: '\u1794\u17b6\u1793\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u1780\u17b6\u179a\u1780\u17c6\u178e\u178f\u17cb\u1782\u17bc\u1794\u17d2\u179a\u1780\u17bd\u178f\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    booking_open_opponents_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u1780\u17b6\u179a\u1794\u17be\u1780\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1782\u17bc\u1794\u17d2\u179a\u1780\u17bd\u178f',
    booking_cancel_matched_title: '\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178a\u17c2\u179b\u1794\u17b6\u1793\u1795\u17d2\u1782\u17bc\u1795\u17d2\u1782\u1784',
    booking_cancel_matched_confirm: '\u178f\u17be\u17a2\u17d2\u1793\u1780\u1785\u1784\u17cb\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178a\u17c2\u179b\u1794\u17b6\u1793\u1795\u17d2\u1782\u17bc\u1795\u17d2\u1782\u1784\u1793\u17c1\u17c7\u1798\u17c2\u1793\u1791\u17c1: {{home}} \u1791\u179b\u17cb\u1793\u17b9\u1784 {{away}}?',
    booking_matched_cancelled_success: '\u1794\u17b6\u1793\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb\u178a\u17c2\u179b\u1794\u17b6\u1793\u1795\u17d2\u1782\u17bc\u1795\u17d2\u1782\u1784\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    booking_cancel_matched_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178a\u17c2\u179b\u1794\u17b6\u1793\u1795\u17d2\u1782\u17bc\u1795\u17d2\u1782\u1784',
    booking_join_request_approved: '\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    booking_join_request_rejected: '\u1794\u17b6\u1793\u1794\u178a\u17b7\u179f\u17c1\u1792\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    booking_join_request_approve_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798',
    booking_join_request_reject_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1794\u178a\u17b7\u179f\u17c1\u1792\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798',
    booking_cancellation_requested: '\u1794\u17b6\u1793\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6\u1794\u17c4\u17c7\u1794\u1784\u17cb\u17d4 \u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u17d4',
    booking_request_cancellation: '\u179f\u17d2\u1793\u17be\u1780\u17b6\u179a\u1794\u17c4\u17c7\u1794\u1784\u17cb',
    booking_send_cancellation_for: '\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be\u1794\u17c4\u17c7\u1794\u1784\u17cb\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb',
    booking_this_booking: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1793\u17c1\u17c7',
    booking_reason_for_cancellation: '\u1798\u17bc\u179b\u17a0\u17c1\u178f\u17bb\u1793\u17c3\u1780\u17b6\u179a\u1794\u17c4\u17c7\u1794\u1784\u17cb',
    booking_reason_placeholder: '\u1787\u17b6\u1787\u1798\u17d2\u179a\u17be\u179f\u17d6 \u1796\u1793\u17d2\u1799\u179b\u17cb\u1798\u17bc\u179b\u17a0\u17c1\u178f\u17bb\u178a\u17c2\u179b\u17a2\u17d2\u1793\u1780\u1785\u1784\u17cb\u1794\u17c4\u17c7\u1794\u1784\u17cb\u1780\u17b6\u179a\u1780\u1780\u17cb\u1793\u17c1\u17c7...',
    booking_requesting: '\u1780\u17c6\u1796\u17bb\u1784\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6...',
    booking_send_request: '\u1795\u17d2\u1789\u17be\u179f\u17c6\u178e\u17be',
    booking_vs: '\u1791\u179b\u17cb\u1793\u17b9\u1784',
    team_details_about: '\u17a2\u17c6\u1796\u17b8\u1780\u17d2\u179a\u17bb\u1798\u1793\u17c1\u17c7',
    team_details_about_desc: '\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u1791\u17bc\u1791\u17c5 \u1793\u17b7\u1784\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1794\u17d2\u179a\u17bc\u17a0\u17d2\u179c\u17b6\u1799\u179b\u17c1\u17a2\u1780\u1793\u17d2\u179b\u17c2\u1784\u178f\u17c2\u1798\u17bd\u1799\u17d4',
    team_details_description: '\u1780\u17b6\u179a\u1796\u17b7\u1796\u178e\u17cc\u1793\u17b6',
    team_details_no_description: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1796\u17b7\u1796\u178e\u17cc\u1793\u17b6\u1780\u17d2\u179a\u17bb\u1798\u1793\u17c5\u17a1\u17be\u1799\u1791\u17c1\u17d4',
    team_details_recent_history: '\u1794\u17d2\u179a\u179c\u178f\u17d2\u178f\u17b7\u1790\u17d2\u1798\u17b8\u17c7',
    team_details_recent_history_desc: '\u179b\u1791\u17d2\u1792\u1795\u179b \u1782\u17bc\u1794\u17d2\u179a\u1780\u17bd\u178f \u1793\u17b7\u1784\u1780\u17b6\u179b\u1794\u179a\u17b7\u1785\u17d2\u1786\u17c1\u1791\u1794\u17d2\u179a\u1780\u17bd\u178f\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17d2\u179a\u17bb\u1798\u1793\u17c1\u17c7\u17d4',
    team_details_shown: '\u1794\u1784\u17d2\u17a0\u17b6\u1789 {{count}}',
    team_details_no_recent_matches: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1794\u17d2\u179a\u1780\u17bd\u178f\u178a\u17c2\u179b\u1794\u17b6\u1793\u1794\u1789\u17d2\u1785\u1794\u17cb\u1780\u17d2\u1793\u17bb\u1784\u1796\u17c1\u179b\u1780\u17d2\u179a\u17c4\u1799\u1791\u17c1\u17d4',
    team_details_notes: '\u1780\u17c6\u178e\u178f\u17cb\u1785\u17c6\u178e\u17b6\u17c6\u1780\u17d2\u179a\u17bb\u1798',
    team_details_notes_desc: '\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1782\u17b6\u17c6\u1791\u17d2\u179a\u178a\u17c2\u179b\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1794\u17b6\u1793\u1794\u1784\u17d2\u17a0\u17b6\u1789\u179a\u17bd\u1785\u1793\u17c5\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u178f\u179f\u1784\u17d2\u1781\u17c1\u1794\u1781\u17b6\u1784\u179b\u17be\u17d4',
    team_details_squad_capacity: '\u1785\u17c6\u178e\u17bb\u17c7\u1780\u17d2\u179a\u17bb\u1798: {{count}} \u1793\u17b6\u1780\u17cb',
    team_details_status_line: '\u179f\u17d2\u1790\u17b6\u1793\u1797\u17b6\u1796\u1780\u17d2\u179a\u17bb\u1798: {{status}}',
    team_details_created_on: '\u1794\u1784\u17d2\u1780\u17be\u178f\u1793\u17c5 {{date}}',
    team_details_jersey_selected: '\u1794\u17b6\u1793\u1787\u17d2\u179a\u17be\u179f\u179a\u17be\u179f\u1796\u178e\u17cc\u17a2\u17b6\u179c\u1780\u17d2\u179a\u17bb\u1798 {{count}}',
    team_details_notes_helper: '\u1780\u17b6\u178f\u179f\u1784\u17d2\u1781\u17c1\u1794\u1781\u17b6\u1784\u179b\u17be\u17a5\u17a1\u17bc\u179c\u1793\u17c1\u17c7\u1795\u17d2\u1791\u17bb\u1780\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u17a2\u178f\u17d2\u178f\u179f\u1789\u17d2\u1789\u17b6\u178e\u179f\u17c6\u1781\u17b6\u1793\u17cb\u17be\u1799 \u1795\u17d2\u1793\u17c2\u1780\u1793\u17c1\u17c7\u1791\u17bb\u1780\u178f\u17c2\u1794\u179a\u17b7\u1794\u1791\u1794\u1793\u17d2\u1790\u17c2\u1798\u1794\u17c9\u17bb\u178e\u17d2\u178e\u17c4\u17c7\u17d4',
    team_details_admin_view: '\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u17a2\u17d2\u1793\u1780\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1794\u17d2\u179a\u17bc\u17a0\u17d2\u179c\u17b6\u1799\u179b\u17c1\u1780\u17d2\u179a\u17bb\u1798 \u179f\u1798\u17b6\u1787\u17b7\u1780 \u1793\u17b7\u1784\u1794\u17d2\u179a\u179c\u178f\u17d2\u178f\u17b7\u1790\u17d2\u1798\u17b8\u17c7\u17d4',
    team_details_you_are_captain: '\u17a2\u17d2\u1793\u1780\u1782\u17ba\u1787\u17b6\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793\u1793\u17c3\u1780\u17d2\u179a\u17bb\u1798\u1793\u17c1\u17c7\u17d4',
    team_details_invited: '\u17a2\u17d2\u1793\u1780\u178f\u17d2\u179a\u17bc\u179c\u1794\u17b6\u1793\u17a2\u1789\u17d2\u1787\u17be\u1789\u17b1\u17d2\u1799\u1785\u17bc\u179b\u179a\u17bd\u1798\u1780\u17d2\u179a\u17bb\u1798\u1793\u17c1\u17c7\u17d4',
    team_details_join_pending: '\u179f\u17c6\u178e\u17be\u1785\u17bc\u179b\u179a\u17bd\u1798\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6\u1780\u17b6\u179a\u17a2\u1793\u17bb\u1798\u17d0\u178f\u17d4',
    team_details_leaving: '\u1780\u17c6\u1796\u17bb\u1784\u1785\u17b6\u1780\u1785\u17c1\u1789...',
    team_details_leave_team: '\u1785\u17b6\u1780\u1785\u17c1\u1789\u1796\u17b8\u1780\u17d2\u179a\u17bb\u1798',
    team_details_players: '\u1793\u17b6\u1780\u17cb',
    team_details_no_active_members: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u179f\u1798\u17b6\u1787\u17b7\u1780\u1780\u17c6\u1796\u17bb\u1784\u179f\u1780\u1798\u17d2\u1798\u1793\u17c5\u17a1\u17be\u1799\u1791\u17c1\u17d4',
    dashboard_admin_pending_approvals: '\u1780\u17b6\u179a\u17a2\u1793\u17bb\u1798\u17d0\u178f\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6 \u178a\u17c2\u179b\u178f\u17d2\u179a\u17bc\u179c\u1780\u17b6\u179a\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1796\u17b8\u17a2\u17d2\u1793\u1780\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784',
    dashboard_admin_latest_activity: '\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799\u1791\u17bc\u1791\u17b6\u17c6\u1784\u1794\u17d2\u179a\u1796\u17d0\u1793\u17d2\u1792',
    dashboard_admin_review_role_requests: '\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u17c6\u178e\u17be\u178f\u17bd\u1793\u17b6\u1791\u17b8',
    dashboard_admin_approve_access: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17b7\u1791\u17d2\u1792\u17b7\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793 \u1793\u17b7\u1784\u1798\u17d2\u1785\u17b6\u179f\u17cb',
    dashboard_admin_manage_users: '\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be',
    dashboard_admin_inspect_members: '\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u1798\u17b6\u1787\u17b7\u1780\u1791\u17bc\u1791\u17b6\u17c6\u1784\u1794\u17d2\u179a\u1796\u17d0\u1793\u17d2\u1792',
    dashboard_admin_check_bookings: '\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1780\u17b6\u179a\u1780\u1780\u17cb',
    dashboard_admin_monitor_bookings: '\u178f\u17b6\u1798\u178a\u17b6\u1793\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796\u1780\u17b6\u179a\u1780\u1780\u17cb',
    dashboard_admin_pending_role_requests: '\u179f\u17c6\u178e\u17be\u178f\u17bd\u1793\u17b6\u1791\u17b8\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6',
    dashboard_admin_recent_access_requests: '\u179f\u17c6\u178e\u17be\u179f\u17b7\u1791\u17d2\u1792\u17b7\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799 \u178a\u17c2\u179b\u178f\u17d2\u179a\u17bc\u179c\u1780\u17b6\u179a\u1780\u17b6\u179a\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1796\u17b8\u1781\u17b6\u1784 admin\u17d4',
    dashboard_admin_review_all: '\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u1791\u17b6\u17c6\u1784\u17a2\u179f\u17cb',
    dashboard_admin_no_pending_role_requests: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u179f\u17c6\u178e\u17be\u178f\u17bd\u1793\u17b6\u1791\u17b8\u1780\u17c6\u1796\u17bb\u1784\u179a\u1784\u17cb\u1785\u17b6\u17c6',
    dashboard_admin_newest_users: '\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u1790\u17d2\u1798\u17b8\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799',
    dashboard_admin_active: '\u179f\u1780\u1798\u17d2\u1798',
    dashboard_admin_suspended: '\u1795\u17d2\u17a2\u17b6\u1780',
    dashboard_admin_no_users: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be',
    dashboard_admin_users_appear: '\u1782\u178e\u1793\u17b8\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u1793\u17b9\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7 \u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb\u1796\u17b8\u1785\u17bb\u17c7\u17c8\u1794\u1789\u17d2\u1787\u17b8\u17d4',
    dashboard_admin_latest_bookings: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799',
    dashboard_admin_view_bookings: '\u1798\u17be\u179b\u1780\u17b6\u179a\u1780\u1780\u17cb',
    dashboard_admin_no_bookings: '\u1798\u17b7\u1793\u1791\u17b6\u1793\u17cb\u1798\u17b6\u1793\u1780\u17b6\u179a\u1780\u1780\u17cb',
    dashboard_admin_bookings_appear: '\u1780\u17b6\u179a\u1780\u1780\u17cb\u1785\u17bb\u1784\u1780\u17d2\u179a\u17c4\u1799\u1793\u17b9\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789\u1793\u17c5\u1791\u17b8\u1793\u17c1\u17c7 \u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb\u1780\u17b6\u179a\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799 admin \u1799\u17c9\u17b6\u1784\u1786\u17b6\u1794\u17cb\u179a\u17a0\u17d0\u179f\u17d4',
    admin_users_badge: '\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be admin',
    admin_users_subtitle: '\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u178f\u17bd\u1793\u17b6\u1791\u17b8 \u179f\u17d2\u1790\u17b6\u1793\u1797\u17b6\u1796\u1782\u178e\u1793\u17b8 \u1793\u17b7\u1784\u179b\u17bb\u1794\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be \u178a\u17c4\u1799\u1798\u17b6\u1793\u1791\u17b7\u178a\u17d2\u178b\u1797\u17b6\u1796\u1784\u17b6\u1799\u1799\u179b\u17cb\u1787\u17b6\u1784\u1798\u17bb\u1793\u17d4',
    admin_users_total: '\u179f\u179a\u17bb\u1794',
    admin_users_admins: '\u17a2\u17d2\u1793\u1780\u1782\u17d2\u179a\u1794\u17cb\u1782\u17d2\u179a\u1784',
    admin_users_tab_all: '\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u1791\u17b6\u17c6\u1784\u17a2\u179f\u17cb',
    admin_users_role_hint: '\u178f\u17d2\u179a\u1784\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u178f\u17b6\u1798\u178f\u17bd\u1793\u17b6\u1791\u17b8 \u178a\u17be\u1798\u17d2\u1794\u17b8\u17b1\u17d2\u1799 admin \u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u17a2\u17d2\u1793\u1780\u179b\u17c1\u1784 \u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793 \u1793\u17b7\u1784\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793\u1794\u17b6\u1793\u179b\u17bf\u1793\u1787\u17b6\u1784\u1798\u17bb\u1793\u17d4',
    admin_users_search_placeholder: '\u179f\u17d2\u179c\u17c2\u1784\u179a\u1780 username \u17a2\u17ca\u17b8\u1798\u17c2\u179b \u17ac\u1788\u17d2\u1798\u17c4\u17c7',
    admin_users_all_roles: '\u1782\u17d2\u179a\u1794\u17cb\u178f\u17bd\u1793\u17b6\u1791\u17b8',
    admin_users_all_statuses: '\u1782\u17d2\u179a\u1794\u17cb\u179f\u17d2\u1790\u17b6\u1793\u1797\u17b6\u1796',
    admin_users_sort_newest: '\u1790\u17d2\u1798\u17b8\u1794\u17c6\u1795\u17bb\u178f\u1798\u17bb\u1793',
    admin_users_sort_oldest: '\u1785\u17b6\u179f\u17cb\u1794\u17c6\u1795\u17bb\u178f\u1798\u17bb\u1793',
    admin_users_sort_activity: '\u179f\u1780\u1798\u17d2\u1798\u1794\u17c6\u1795\u17bb\u178f',
    admin_users_inactive: '\u1798\u17b7\u1793\u179f\u1780\u1798\u17d2\u1798',
    admin_users_user: '\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be',
    admin_users_email: '\u17a2\u17ca\u17b8\u1798\u17c2\u179b',
    admin_users_role: '\u178f\u17bd\u1793\u17b6\u1791\u17b8',
    admin_users_status: '\u179f\u17d2\u1790\u17b6\u1793\u1797\u17b6\u1796',
    admin_users_actions: '\u179f\u1780\u1798\u17d2\u1798\u1797\u17b6\u1796',
    admin_users_showing: '\u1780\u17c6\u1796\u17bb\u1784\u1794\u1784\u17d2\u17a0\u17b6\u1789 {{start}}-{{end}} \u1793\u17c3\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be {{total}}',
    admin_users_prev_page: '\u1798\u17bb\u1793',
    admin_users_next_page: '\u1794\u1793\u17d2\u1791\u17b6\u1794\u17cb',
    admin_users_loading: '\u1780\u17c6\u1796\u17bb\u1784\u1795\u17d2\u1791\u17bb\u1780\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be...',
    admin_users_none_found: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u178e\u17b6\u1798\u17bd\u1799\u1795\u17d2\u1782\u17bc\u1795\u17d2\u1782\u1784\u1793\u17b9\u1784\u178f\u1798\u17d2\u179a\u1784\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u17d4',
    admin_users_load_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1795\u17d2\u1791\u17bb\u1780\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u17d4',
    admin_users_delete_title: '\u179b\u17bb\u1794\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be',
    admin_users_delete_confirm: '\u179b\u17bb\u1794\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be @{{username}}? \u1798\u17b7\u1793\u17a2\u17b6\u1785\u1794\u17c4\u17c7\u1794\u1784\u17cb\u179c\u17b7\u1789\u1794\u17b6\u1793\u1791\u17c1\u17d4',
    admin_users_delete_success: '\u1794\u17b6\u1793\u179b\u17bb\u1794\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    admin_users_delete_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u179b\u17bb\u1794\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u17d4',
    admin_users_details_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1795\u17d2\u1791\u17bb\u1780\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u17d4',
    admin_users_update_success: '\u1794\u17b6\u1793\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u178a\u17c4\u1799\u1787\u17c4\u1782\u1787\u17d0\u1799\u17d4',
    admin_users_update_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1792\u17d2\u179c\u17be\u1794\u1785\u17d2\u1785\u17bb\u1794\u17d2\u1794\u1793\u17d2\u1793\u1797\u17b6\u1796\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be\u17d4',
    admin_role_requests_badge: '\u1780\u17b6\u179a\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u17b7\u1791\u17d2\u1792\u17b7',
    admin_role_requests_subtitle: '\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u17c6\u178e\u17be\u179f\u17b7\u1791\u17d2\u1792\u17b7\u1780\u17b6\u1796\u17b8\u178f\u17c2\u1793 \u1793\u17b7\u1784\u1798\u17d2\u1785\u17b6\u179f\u17cb\u1791\u17b8\u179b\u17b6\u1793 \u178a\u17c4\u1799\u1794\u17d2\u179a\u17be\u179a\u17c5\u1794\u1794\u1791\u17b6\u178f\u17cb dashboard \u178a\u17c2\u179b\u1798\u17b6\u1793\u179a\u17bd\u1794\u179a\u17b6\u1784\u178a\u17bc\u1785\u1782\u17d2\u1793\u17b6\u17d4',
    admin_role_requests_total: '\u179f\u179a\u17bb\u1794',
    admin_role_requests_approved: '\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798',
    admin_role_requests_rejected: '\u1794\u17b6\u1793\u1794\u178a\u17b7\u179f\u17c1\u1792',
    admin_role_requests_search: '\u179f\u17d2\u179c\u17c2\u1784\u179a\u1780 username \u17a2\u17ca\u17b8\u1798\u17c2\u179b \u1788\u17d2\u1798\u17c4\u17c7 \u17ac\u178f\u17bd\u1793\u17b6\u1791\u17b8',
    admin_role_requests_load_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1795\u17d2\u1791\u17bb\u1780\u179f\u17c6\u178e\u17be\u178f\u17bd\u1793\u17b6\u1791\u17b8\u17d4',
    admin_role_requests_confirm: '\u178f\u17be\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17b6\u1780\u178a\u1790\u17b6\u1785\u1784\u17cb {{action}} \u179f\u17c6\u178e\u17be\u1793\u17c1\u17c7\u1798\u17c2\u1793\u1791\u17c1?',
    admin_role_requests_approve: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798',
    admin_role_requests_reject: '\u1794\u178a\u17b7\u179f\u17c1\u1792',
    admin_role_requests_approve_title: '\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be',
    admin_role_requests_reject_title: '\u1794\u178a\u17b7\u179f\u17c1\u1792\u179f\u17c6\u178e\u17be',
    admin_role_requests_request_approved: '\u1794\u17b6\u1793\u1799\u179b\u17cb\u1796\u17d2\u179a\u1798\u179f\u17c6\u178e\u17be\u17d4',
    admin_role_requests_request_rejected: '\u1794\u17b6\u1793\u1794\u178a\u17b7\u179f\u17c1\u1792\u179f\u17c6\u178e\u17be\u17d4',
    admin_role_requests_review_failed: '\u1794\u179a\u17b6\u1787\u17d0\u1799\u1780\u17d2\u1793\u17bb\u1784\u1780\u17b6\u179a\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u179f\u17c6\u178e\u17be\u17d4',
    admin_role_requests_loading: '\u1780\u17c6\u1796\u17bb\u1784\u1795\u17d2\u1791\u17bb\u1780\u179f\u17c6\u178e\u17be...',
    admin_role_requests_none_found: '\u1798\u17b7\u1793\u1798\u17b6\u1793\u179f\u17c6\u178e\u17be\u178f\u17bd\u1793\u17b6\u1791\u17b8\u17d4',
    admin_role_requests_requested_role: '\u178f\u17bd\u1793\u17b6\u1791\u17b8\u178a\u17c2\u179b\u1794\u17b6\u1793\u179f\u17d2\u1793\u17be\u179f\u17bb\u17c6',
    admin_role_requests_upgrade_fee: '\u1780\u1798\u17d2\u179a\u17c3 upgrade',
    admin_role_requests_payment: '\u1780\u17b6\u179a\u1791\u17bc\u1791\u17b6\u178f\u17cb',
    admin_role_requests_paid: '\u1794\u17b6\u1793\u1794\u1784\u17cb',
    admin_role_requests_note: '\u1780\u17c6\u178e\u178f\u17cb\u1785\u17c6\u178e\u17b6\u17c6',
    admin_role_requests_submitted: '\u1794\u17b6\u1793\u178a\u17b6\u1780\u17cb\u179f\u17c6\u178e\u17be',
    admin_role_requests_reviewed_by: '\u1794\u17b6\u1793\u1796\u17b7\u1793\u17b7\u178f\u17d2\u1799\u178a\u17c4\u1799 {{user}} \u1793\u17c5 {{date}}',
    admin_role_requests_processing: '\u1780\u17c6\u1796\u17bb\u1784\u178a\u17c6\u178e\u17be\u179a\u1780\u17b6\u179a...',
    admin_role_requests_user_details: '\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u17a2\u17d2\u1793\u1780\u1794\u17d2\u179a\u17be',
    admin_role_requests_view_account: '\u1798\u17be\u179b\u1796\u17d0\u178f\u17cc\u1798\u17b6\u1793\u1782\u178e\u1793\u17b8\u179f\u1798\u17d2\u179a\u17b6\u1794\u17cb @{{username}}\u17d4',
    admin_role_requests_no_email: '\u1782\u17d2\u1798\u17b6\u1793\u17a2\u17ca\u17b8\u1798\u17c2\u179b',
    admin_role_requests_no_phone: '\u1782\u17d2\u1798\u17b6\u1793\u179b\u17c1\u1781\u1791\u17bc\u179a\u179f\u17d0\u1796\u17d2\u1791',
    admin_role_requests_no_address: '\u1782\u17d2\u1798\u17b6\u1793\u17a2\u17b6\u179f\u17d0\u1799\u178a\u17d2\u178b\u17b6\u1793'
  }
};

const TEXT_NODE_ORIGINALS = new WeakMap();
const TEXT_NODE_TRANSLATIONS = new WeakMap();
const ATTRIBUTE_ORIGINALS = new WeakMap();
const ATTRIBUTE_TRANSLATIONS = new WeakMap();
const TRANSLATABLE_ATTRIBUTES = ['placeholder', 'title', 'aria-label'];
const SKIP_TRANSLATION_SELECTOR = 'script, style, noscript, textarea, input[data-i18n-ignore], [data-i18n-ignore="true"]';

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const preserveWhitespace = (original, translated) => {
  const leading = original.match(/^\s*/)?.[0] || '';
  const trailing = original.match(/\s*$/)?.[0] || '';
  return `${leading}${translated}${trailing}`;
};

const phraseEntries = Object.entries(translations.en)
  .map(([key, englishValue]) => {
    const khmerValue = translations.km?.[key];
    if (typeof englishValue !== 'string' || typeof khmerValue !== 'string') {
      return null;
    }

    const normalizedEnglish = englishValue.trim();
    const normalizedKhmer = khmerValue.trim();
    if (!normalizedEnglish || !normalizedKhmer || normalizedEnglish === normalizedKhmer) {
      return null;
    }

    const tokens = [];
    const patternSource = escapeRegExp(normalizedEnglish).replace(/\\\{\\\{\s*([\w]+)\s*\\\}\\\}/g, (_, token) => {
      tokens.push(token);
      return '(.+?)';
    });

    return {
      english: normalizedEnglish,
      khmer: normalizedKhmer,
      regex: new RegExp(`^${patternSource}$`),
      tokens
    };
  })
  .filter(Boolean)
  .sort((first, second) => second.english.length - first.english.length);

const translateStaticPhrase = (text) => {
  const normalized = text.trim();
  if (!normalized) return text;

  for (const entry of phraseEntries) {
    const match = normalized.match(entry.regex);
    if (!match) continue;

    let translated = entry.khmer;
    entry.tokens.forEach((token, index) => {
      translated = translated.replaceAll(`{{${token}}}`, match[index + 1]);
    });
    return preserveWhitespace(text, translated);
  }

  return text;
};

const shouldSkipElement = (element) =>
  !element ||
  !(element instanceof HTMLElement) ||
  element.matches(SKIP_TRANSLATION_SELECTOR) ||
  element.closest(SKIP_TRANSLATION_SELECTOR);

const processTextNode = (node, language) => {
  const currentValue = node.nodeValue || '';
  const previousTranslated = TEXT_NODE_TRANSLATIONS.get(node);

  if (language === 'km') {
    if (!TEXT_NODE_ORIGINALS.has(node) || (previousTranslated && currentValue !== previousTranslated)) {
      TEXT_NODE_ORIGINALS.set(node, currentValue);
    }

    const source = TEXT_NODE_ORIGINALS.get(node) ?? currentValue;
    const translated = translateStaticPhrase(source);
    TEXT_NODE_TRANSLATIONS.set(node, translated);

    if (translated !== currentValue) {
      node.nodeValue = translated;
    }
    return;
  }

  const original = TEXT_NODE_ORIGINALS.get(node);
  if (typeof original === 'string' && currentValue !== original) {
    node.nodeValue = original;
  }
  TEXT_NODE_TRANSLATIONS.delete(node);
};

const processElementAttributes = (element, language) => {
  TRANSLATABLE_ATTRIBUTES.forEach((attributeName) => {
    if (!element.hasAttribute(attributeName)) return;

    const currentValue = element.getAttribute(attributeName) || '';
    const originalAttributes = ATTRIBUTE_ORIGINALS.get(element) || {};
    const translatedAttributes = ATTRIBUTE_TRANSLATIONS.get(element) || {};

    if (language === 'km') {
      if (!(attributeName in originalAttributes) || (translatedAttributes[attributeName] && currentValue !== translatedAttributes[attributeName])) {
        originalAttributes[attributeName] = currentValue;
      }

      const source = originalAttributes[attributeName] ?? currentValue;
      const translated = translateStaticPhrase(source);
      translatedAttributes[attributeName] = translated;

      if (translated !== currentValue) {
        element.setAttribute(attributeName, translated);
      }

      ATTRIBUTE_ORIGINALS.set(element, originalAttributes);
      ATTRIBUTE_TRANSLATIONS.set(element, translatedAttributes);
      return;
    }

    if (attributeName in originalAttributes && currentValue !== originalAttributes[attributeName]) {
      element.setAttribute(attributeName, originalAttributes[attributeName]);
    }
  });

  if (element instanceof HTMLInputElement) {
    const isButtonLike = ['button', 'submit', 'reset'].includes(element.type);
    if (!isButtonLike || !element.value) return;

    const originalAttributes = ATTRIBUTE_ORIGINALS.get(element) || {};
    const translatedAttributes = ATTRIBUTE_TRANSLATIONS.get(element) || {};

    if (language === 'km') {
      if (!('value' in originalAttributes) || (translatedAttributes.value && element.value !== translatedAttributes.value)) {
        originalAttributes.value = element.value;
      }

      const translated = translateStaticPhrase(originalAttributes.value);
      translatedAttributes.value = translated;
      if (translated !== element.value) {
        element.value = translated;
      }

      ATTRIBUTE_ORIGINALS.set(element, originalAttributes);
      ATTRIBUTE_TRANSLATIONS.set(element, translatedAttributes);
      return;
    }

    if ('value' in originalAttributes && element.value !== originalAttributes.value) {
      element.value = originalAttributes.value;
    }
  }
};

const translateDomSubtree = (rootNode, language) => {
  if (typeof document === 'undefined' || !rootNode) return;

  if (rootNode.nodeType === Node.TEXT_NODE) {
    const parentElement = rootNode.parentElement;
    if (!shouldSkipElement(parentElement)) {
      processTextNode(rootNode, language);
    }
    return;
  }

  if (rootNode.nodeType !== Node.ELEMENT_NODE || shouldSkipElement(rootNode)) {
    return;
  }

  processElementAttributes(rootNode, language);

  const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
  let currentNode = walker.currentNode;

  while (currentNode) {
    if (currentNode.nodeType === Node.TEXT_NODE) {
      if (!shouldSkipElement(currentNode.parentElement)) {
        processTextNode(currentNode, language);
      }
    } else {
      processElementAttributes(currentNode, language);
    }

    currentNode = walker.nextNode();
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      return localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';
    } catch {
      return 'en';
    }
  });

  const changeLanguage = useCallback((nextLanguage) => {
    const safe = nextLanguage === 'km' ? 'km' : 'en';
    if (safe === language) return;

    startTransition(() => {
      setLanguage(safe);
    });
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, safe);
    } catch {}
  }, [language]);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    translateDomSubtree(document.body, language);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          translateDomSubtree(mutation.target, language);
          return;
        }

        if (mutation.type === 'attributes') {
          translateDomSubtree(mutation.target, language);
          return;
        }

        mutation.addedNodes.forEach((node) => translateDomSubtree(node, language));
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: TRANSLATABLE_ATTRIBUTES
    });

    return () => observer.disconnect();
  }, [language]);

  const translate = useCallback((key, fallback, replacements = {}) => {
    const template = translations[language]?.[key] || fallback || key;
    return Object.entries(replacements).reduce(
      (result, [token, value]) => result.replaceAll(`{{${token}}}`, String(value)),
      template
    );
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage: changeLanguage,
      t: translate
    }),
    [changeLanguage, language, translate]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};



